{
	"dialog.ok": "Okay",
	"dialog.cancel": "Abbrechen",
	"dialog.confirm": "Bestätigen",
	"dialog.close": "Schließen",
	"dialog.import": "Importieren",
	"dialog.save": "Speichern",
	"dialog.discard": "Verwerfen",
	"dialog.dontshowagain": "Nicht erneut anzeigen",
	"data.cube": "Würfel",
	"data.group": "Gruppe",
	"data.texture": "Textur",
	"data.plugin": "Plugin",
	"data.preview": "Vorschau",
	"data.toolbar": "Werkzeugleiste",
	"data.image": "Bild",
	"keys.ctrl": "Strg",
	"keys.shift": "Umschalt",
	"keys.alt": "Alt",
	"keys.meta": "Cmd",
	"keys.delete": "Entfernen",
	"keys.space": "Leertaste",
	"keys.leftclick": "Linksklick",
	"keys.middleclick": "Mittelklick",
	"keys.rightclick": "Rechtsklick",
	"keys.tab": "Tab",
	"keys.backspace": "Rücktaste",
	"keys.enter": "Eingabe",
	"keys.escape": "Escape",
	"keys.function": "F%0",
	"keys.numpad": "Ziffernblock %0",
	"keys.caps": "Feststelltaste",
	"keys.menu": "Kontextmenü",
	"keys.left": "Pfeil links",
	"keys.up": "Pfeil hoch",
	"keys.right": "Pfeil rechts",
	"keys.down": "Pfeil runter",
	"keys.pageup": "Bild auf",
	"keys.pagedown": "Bild ab",
	"keys.plus": "Plus",
	"keys.comma": "Komma",
	"keys.point": "Punkt",
	"keys.minus": "Minus",
	"keys.cross": "Kreuz",
	"keys.end": "Ende",
	"keys.pos1": "Position 1",
	"keys.printscreen": "Drucken",
	"keys.pause": "Pause",
	"message.rotation_limit.title": "Rotationsbegrenzung",
	"message.rotation_limit.message": "Rotationen sind von Minecraft auf nur eine Achse und 22,5°-Schritte begrenzt. Das Drehen auf einer weiteren Achse setzt alle anderen Achsen zurück. Konvertiere das Modell in ein „generisches Modell“, wenn du freie Rotationen benötigst.",
	"message.file_not_found.title": "Datei nicht gefunden",
	"message.file_not_found.message": "Blockbench konnte die angeforderte Datei nicht finden. Überprüfe, ob die Datei lokal gespeichert ist und nicht in einer Cloud.",
	"message.screenshot.title": "Bildschirmfoto",
	"message.screenshot.clipboard": "Zwischenablage",
	"message.screenshot.right_click": "Bildschirmfoto – Rechtsklicken oder gedrückt halten zum Kopieren",
	"message.invalid_file.title": "Ungültige Datei",
	"message.invalid_file.message": "Konnte die Modelldatei nicht öffnen: %0",
	"message.invalid_model.title": "Ungültige Modelldatei",
	"message.invalid_model.message": "Diese Datei enthält kein gültiges Modell",
	"message.child_model_only.title": "Leeres Untermodell",
	"message.child_model_only.message": "Dieses Modell ist ein Untermodell von %0 und enthält kein eigenes Modell.",
	"message.unsaved_textures.title": "Ungespeicherte Texturen",
	"message.unsaved_textures.message": "Dein Modell hat ungespeicherte Texturen. Um sicherzugehen, dass das Modell funktioniert, solltest du diese in dem entsprechenden Ordner im Ressourcenpaket speichern.",
	"message.model_clipping.title": "Modell zu groß",
	"message.model_clipping.message": "Dein Modell enthält %0 Elemente, die größer sind als die Blockbegrenzung von 3×3×3, die Minecraft zulässt. Dieses Modell wird so nicht in Minecraft funktionieren.",
	"message.loose_texture.title": "Texturenimport",
	"message.loose_texture.message": "Die geladene Textur befindet sich nicht in einem Ressourcenpaket. Minecraft kann nur Texturen laden, die sich innerhalb des Texturenordners eines Ressourcenpakets befindet.",
	"message.loose_texture.change": "Pfad Verändern",
	"message.update_res.title": "Auflösung",
	"message.update_res.message": "Möchtest du die Auflösung des Projekts an die Auflösung dieser Textur anpassen? Wähle „Abbrechen“, wenn die Textur eine höhere Auflösung haben soll.",
	"message.update_res.update": "Anpassen",
	"message.bedrock_overwrite_error.message": "Blockbench kann dieses Modell nicht mit der alten Modelldatei vereinen",
	"message.bedrock_overwrite_error.backup_overwrite": "Sicherungskopie erstellen und überschreiben",
	"message.bedrock_overwrite_error.overwrite": "Überschreiben",
	"message.close_warning.message": "Möchtest du dein Modell speichern?",
	"message.close_warning.web": "Bist du sicher, dass du das Programm verlassen möchtest? Dadurch geht die momentane Arbeit verloren.",
	"message.default_textures.title": "Standardtexturen",
	"message.default_textures.message": "Wähle den „textures“-Ordner deines Ressourcenpakets",
	"message.default_textures.detail": "Extrahiere das Standard-Ressourcenpaket aus der Minecraft-.jar-Datei oder lade es aus dem Internet herunter. Suche dann den „textures“-Ordner und öffne diesen. Blockbench merkt sich diesen Ordner und greift in Zukunft darauf zurück, wenn es die Texturen nicht anderweitig finden kann.",
	"message.default_textures.select": "Ordner auswählen",
	"message.image_editor.title": "Wähle ein Bildbearbeitungsprogramm",
	"message.image_editor.file": "Datei auswählen ...",
	"message.image_editor.exe": "Öffne die Programmdatei eines Bildbearbeitungsprogramms",
	"message.display_skin.title": "Minecraft-Skin",
	"message.display_skin.message": "Wähle eine Skindatei von deinem Computer oder gib einen Spielernamen an",
	"message.display_skin.upload": "Skindatei",
	"message.display_skin.reset": "Zurücksetzen",
	"message.invalid_plugin": "Fehlerhafte Plugindatei, siehe Konsole",
	"message.load_plugin_app": "Möchtest du diesem Plugin erlauben, Änderungen an deinem Computer vorzunehmen? Nutze nur Plugins von Personen, denen du vertraust.",
	"message.load_plugin_web": "Möchtest du dieses Plugin laden? Nutze nur Plugins von Personen, denen du vertraust.",
	"message.preset_no_info": "Dieses Preset enthält keine Informationen zu dieser Position",
	"message.restart_to_update": "Starte Blockbench neu, um die Änderungen wirksam werden zu lassen.",
	"message.save_file": "Gespeichert als %0",
	"dialog.project.title": "Projekt",
	"dialog.project.name": "Dateiname",
	"dialog.project.parent": "Elternmodell",
	"dialog.project.geoname": "Modell-ID",
	"dialog.project.ao": "Umgebungsschattierung",
	"dialog.texture.title": "Textur",
	"dialog.texture.variable": "Variable",
	"dialog.texture.namespace": "Namensraum",
	"dialog.texture.folder": "Ordner",
	"dialog.extrude.title": "Grafik extrudieren",
	"dialog.extrude.mode": "Abtastmodus",
	"dialog.extrude.mode.areas": "Bereiche",
	"dialog.extrude.mode.lines": "Zeilen",
	"dialog.extrude.mode.columns": "Spalten",
	"dialog.extrude.mode.pixels": "Pixel",
	"dialog.extrude.opacity": "Minimale Deckkraft",
	"dialog.extrude.scan": "Konvertieren und Importieren",
	"dialog.display_preset.title": "Preset erstellen",
	"dialog.display_preset.message": "Wähle die Positionen, die du speichern möchtest",
	"dialog.display_preset.create": "Erstellen",
	"dialog.select.title": "Auswahl",
	"dialog.select.group": "In ausgewählter Gruppe",
	"dialog.select.name": "Name enthält",
	"dialog.select.random": "Zufallschance (%)",
	"dialog.select.select": "Auswählen",
	"dialog.scale.title": "Modell skalieren",
	"dialog.scale.axis": "Achse",
	"dialog.scale.clipping": "Modellüberstand: Dein Modell ist zu groß",
	"dialog.scale.confirm": "Skalieren",
	"dialog.plugins.title": "Plugins",
	"dialog.plugins.installed": "Installiert",
	"dialog.plugins.available": "Verfügbar",
	"dialog.plugins.install": "Installieren",
	"dialog.plugins.uninstall": "Deinstallieren",
	"dialog.plugins.reload": "Neu laden",
	"dialog.plugins.none_installed": "Keine Plugins installiert",
	"dialog.plugins.none_available": "Keine Plugins verfügbar",
	"dialog.plugins.web_only": "Nur für die Webanwendung",
	"dialog.plugins.app_only": "Nur für die Desktopanwendung",
	"dialog.plugins.author": "von %0",
	"dialog.create_texture.folder": "Ordner",
	"dialog.create_texture.resolution": "Auflösung",
	"dialog.input.title": "Eingabe",
	"dialog.settings.settings": "Einstellungen",
	"dialog.settings.keybinds": "Tastenbelegungen",
	"dialog.settings.about": "Über",
	"layout.color.back": "Hintergrund",
	"layout.color.back.desc": "Hintergründe und Eingabefelder",
	"layout.color.dark": "Dunkel",
	"layout.color.dark.desc": "Hintergrund der Vorschau",
	"layout.color.ui": "Oberfläche",
	"layout.color.ui.desc": "Haupt-Oberflächenfarbe",
	"layout.color.bright_ui": "Helle Oberfläche",
	"layout.color.bright_ui.desc": "Kontextmenüs und Tooltips",
	"layout.color.button": "Schaltfläche",
	"layout.color.button.desc": "Schaltflächen und Schalter",
	"layout.color.selected": "Auswahl",
	"layout.color.selected.desc": "Ausgewählte Objekte und Registerkarten",
	"layout.color.border": "Rahmen",
	"layout.color.border.desc": "Rahmen von Schaltflächen und anderem",
	"layout.color.accent": "Akzent",
	"layout.color.accent.desc": "Akzentfarbe für Details",
	"layout.color.grid": "Gitter",
	"layout.color.grid.desc": "Gitter der 3D-Vorschau",
	"layout.color.text": "Text",
	"layout.color.text.desc": "Normaler Text",
	"layout.color.light": "Hell",
	"layout.color.light.desc": "Ausgewählter Text",
	"layout.color.accent_text": "Akzenttext",
	"layout.color.accent_text.desc": "Text auf hellen- oder Akzent-Elementen",
	"layout.font.main": "Hauptschriftart",
	"layout.font.headline": "Überschriftenschriftart",
	"about.version": "Version: ",
	"settings.category.general": "Allgemein",
	"settings.category.preview": "Vorschau",
	"settings.category.grid": "Gitter",
	"settings.category.edit": "Bearbeiten",
	"settings.category.snapping": "Einrasten",
	"settings.category.defaults": "Standardwerte",
	"settings.category.dialogs": "Dialoge",
	"settings.category.export": "Export",
	"settings.language": "Sprache",
	"settings.language.desc": "Sprache der Benutzeroberfläche. Starte Blockbench neu, um die Änderungen wirksam zu machen.",
	"settings.backup_interval": "Abstand der Sicherheitskopien",
	"settings.backup_interval.desc": "Zeit zwischen den automatischen Sicherheitskopien in Minuten",
	"settings.origin_size": "Angelpunkt",
	"settings.origin_size.desc": "Größe des Angelpunkts",
	"settings.control_size": "Größe des Achsenwerkzeuges",
	"settings.control_size.desc": "Größe des 3-Achsen-Verschiebewerkzeuges",
	"settings.display_skin": "Skin für Anzeigeeinstellungen",
	"settings.display_skin.desc": "Spielerskin, der für das Referenzmodell in den Anzeigeeinstellungen verwendet wird",
	"settings.shading": "Schattierung",
	"settings.shading.desc": "Schattierungen aktivieren",
	"settings.base_grid": "Kleines Gitter",
	"settings.base_grid.desc": "Kleines Gitter und Achsen anzeigen",
	"settings.large_grid": "Blockraster",
	"settings.large_grid.desc": "16×16-Blockraster anzeigen",
	"settings.full_grid": "Genaues Blockraster",
	"settings.full_grid.desc": "Vollständiges, genaues Blockraster anzeigen",
	"settings.large_box": "Blockrahmen",
	"settings.large_box.desc": "3×3×3-Blockbegrenzung anzeigen",
	"settings.display_grid": "Anzeigemodus",
	"settings.display_grid.desc": "Gitter im Anzeigemodus zeigen",
	"settings.undo_limit": "Maximale Rückgängig-Schritte",
	"settings.undo_limit.desc": "Die maximale Anzahl der Bearbeitungen, die für die „Rückgängig“-Funktion aufgezeichnet werden",
	"settings.local_move": "Auf relativen Achsen bewegen",
	"settings.local_move.desc": "Elemente entlang ihrer eigenen, mitgedrehten Achsen bewegen, wenn möglich",
	"settings.canvas_unselect": "Auswahl aufheben",
	"settings.canvas_unselect.desc": "Auswahl beim Klicken auf den Hintergrund aufheben",
	"settings.paint_side_restrict": "Pinsel auf Seite beschränken",
	"settings.paint_side_restrict.desc": "Beschränkt den Pinsel auf das Verändern der Seite, auf die geklickt wurde",
	"settings.autouv": "Auto-UV",
	"settings.autouv.desc": "Auto-UV standardmäßig aktivieren",
	"settings.create_rename": "Neue Elemente umbenennen",
	"settings.create_rename.desc": "Beim Erstellen von Elementen oder Gruppen das Namensfeld zum Umbenennen auswählen",
	"settings.edit_size": "Gitterauflösung",
	"settings.edit_size.desc": "Auflösung des Gitters, an das Elemente einrasten",
	"settings.shift_size": "Auflösung mit Umschalt",
	"settings.shift_size.desc": "Auflösung des Gitters bei gedrückter Umschalttaste",
	"settings.ctrl_size": "Auflösung mit Steuerung",
	"settings.ctrl_size.desc": "Auflösung des Gitters bei gedrückter Steuerungstaste",
	"settings.negative_size": "Negative Größe",
	"settings.negative_size.desc": "Dem Größenwerkzeug negative Werte erlauben",
	"settings.minifiedout": "Reduzierte Ausgabe",
	"settings.minifiedout.desc": "Gesamtes Modell im JSON in eine Zeile schreiben",
	"settings.export_groups": "Gruppen speichern",
	"settings.export_groups.desc": "Gruppen in Modelldateien speichern",
	"settings.credit": "Erstellerkommentar",
	"settings.credit.desc": "Einen Erstellerkommentar zu gespeicherten Dateien hinzufügen",
	"settings.default_path": "Standardpfad für Minecraft-Texturen",
	"settings.default_path.desc": "Ordner, aus dem Blockbench fehlende Standardtexturen lädt",
	"settings.image_editor": "Bildbearbeitungsprogramm",
	"settings.image_editor.desc": "Standard-Bildbearbeitungsprogramm zum externen Bearbeiten von Texturen",
	"category.navigate": "Navigation",
	"category.tools": "Werkzeuge",
	"category.file": "Datei",
	"category.blockbench": "Blockbench",
	"category.edit": "Bearbeiten",
	"category.transform": "Transformieren",
	"category.view": "Ansicht",
	"category.display": "Anzeigeeinstellungen",
	"category.textures": "Texturen",
	"category.misc": "Verschiedenes",
	"keybind.preview_select": "Auswählen",
	"keybind.preview_rotate": "Ansicht drehen",
	"keybind.preview_drag": "Ansicht verschieben",
	"keybind.confirm": "Bestätigen",
	"keybind.cancel": "Abbrechen",
	"action.slider_inflate": "Aufblasen",
	"action.slider_inflate.desc": "Vergrößert Quader in alle Richtungen, ohne dabei die Textur zu verändern",
	"action.slider_brush_size": "Radius",
	"action.slider_brush_size.desc": "Radius des Pinsels in Pixeln",
	"action.slider_brush_opacity": "Deckkraft",
	"action.slider_brush_opacity.desc": "Deckkraft des Pinsels zwischen 0 und 255",
	"action.slider_brush_softness": "Weiche Kanten",
	"action.slider_brush_softness.desc": "Weiche Kanten des Pinsels in Prozent",
	"action.uv_slider_pos_x": "Horizontal bewegen",
	"action.uv_slider_pos_x.desc": "Die UV-Auswahl aller ausgewählten Elemente horizontal verschieben",
	"action.uv_slider_pos_y": "Vertikal bewegen",
	"action.uv_slider_pos_y.desc": "Die UV-Auswahl aller ausgewählten Elemente vertikal verschieben",
	"action.uv_slider_size_x": "Horizontal vergrößern",
	"action.uv_slider_size_x.desc": "Die UV-Auswahl aller ausgewählten Elemente horizontal vergrößern",
	"action.uv_slider_size_y": "Vertikal vergrößern",
	"action.uv_slider_size_y.desc": "Die UV-Auswahl aller ausgewählten Elemente vertikal vergrößern",
	"action.vertex_snap_mode": "Magnetmodus",
	"action.vertex_snap_mode.desc": "Wähle, ob der Eckpunktmagnet Elemente verschiebt oder streckt",
	"action.move_tool": "Verschieben",
	"action.move_tool.desc": "Werkzeug zum Auswählen und Verschieben von Elementen",
	"action.resize_tool": "Größe ändern",
	"action.resize_tool.desc": "Werkzeug zum Auswählen und Ändern der Größe von Elementen",
	"action.brush_tool": "Farbpinsel",
	"action.brush_tool.desc": "Farbpinsel zum Malen auf Texturen",
	"action.vertex_snap_tool": "Eckpunktmagnet",
	"action.vertex_snap_tool.desc": "Verbindet die Ecken von 2 Elementen, indem es das eine verschiebt",
	"action.swap_tools": "Werkzeuge wechseln",
	"action.swap_tools.desc": "Wechselt zwischen dem Verschieben- und Größenwerkzeug",
	"action.project_window": "Projekt ...",
	"action.project_window.desc": "Öffnet die Projekteinstellungen, wo du die Metadaten deines Modells bearbeiten kannst",
	"action.open_model": "Modell öffnen",
	"action.open_model.desc": "Öffne ein Modell von deinem Computer",
	"action.extrude_texture": "3D-Textur",
	"action.extrude_texture.desc": "Erstellt ein 3D-Modell aus einer Textur",
	"action.export_blockmodel": "Block-/Itemmodell exportieren",
	"action.export_blockmodel.desc": "Ein „Minecraft Java Edition“-Block-/Itemmodell exportieren",
	"action.export_optifine_part": "OptiFine JPM exportieren",
	"action.export_optifine_part.desc": "Einen Entity-Komponenten für OptiFine exportieren",
	"action.export_optifine_full": "OptiFine JEM exportieren",
	"action.export_optifine_full.desc": "Ein vollständiges Entitymodell für OptiFine exportieren",
	"action.export_obj": "OBJ-Modell exportieren",
	"action.export_obj.desc": "Ein Wavefront-OBJ-Modell exportieren zum Rendern",
	"action.settings_window": "Einstellungen ...",
	"action.settings_window.desc": "Das Blockbench-Einstellungsmenü öffnen",
	"action.plugins_window": "Plugins ...",
	"action.plugins_window.desc": "Öffnet den Pluginstore",
	"action.reset_layout": "Layout zurücksetzen",
	"action.reset_layout.desc": "Das Layout auf die Standardwerte zurücksetzen",
	"action.load_plugin": "Plugin aus Quelldatei laden",
	"action.load_plugin.desc": "Ein Plugin durch Laden der Quelldatei testen",
	"action.reload_plugins": "Plugins neu laden",
	"action.reload_plugins.desc": "Alle Testplugins neu laden",
	"action.undo": "Rückgängig",
	"action.undo.desc": "Macht die letzte Änderung Rückgängig",
	"action.redo": "Wiederholen",
	"action.redo.desc": "Wiederholt die letzte rückgängig-gemachte Änderung",
	"action.copy": "Kopieren",
	"action.copy.desc": "Kopiert die aktuelle Auswahl, Fläche oder Anzeigeeinstellung",
	"action.paste": "Einfügen",
	"action.paste.desc": "Fügt die aktuelle Auswahl, Fläche oder Anzeigeeinstellung ein",
	"action.cut": "Ausschneiden",
	"action.cut.desc": "Schneidet die aktuelle Auswahl, Fläche oder Anzeigeeinstellung aus",
	"action.add_cube": "Quader hinzufügen",
	"action.add_cube.desc": "Fügt einen neuen Quader hinzu",
	"action.add_group": "Gruppe hinzufügen",
	"action.add_group.desc": "Fügt eine neue Gruppe oder einen neuen Knochen hinzu",
	"action.outliner_toggle": "Mehr Optionen umschalten",
	"action.outliner_toggle.desc": "Aktiviert oder deaktiviert mehr Optionen",
	"action.duplicate": "Duplizieren",
	"action.delete": "Löschen",
	"action.sort_outliner": "Outliner sortieren",
	"action.sort_outliner.desc": "Den Outliner alphabetisch sortieren",
	"action.select_window": "Auswahl ...",
	"action.select_window.desc": "Elemente basierend auf ihren Eigenschaften suchen und auswählen",
	"action.invert_selection": "Auswahl umkehren",
	"action.invert_selection.desc": "Kehrt die aktuelle Auswahl um",
	"action.select_all": "Alle auswählen",
	"action.collapse_groups": "Gruppen einklappen",
	"action.collapse_groups.desc": "Alle Gruppen einklappen",
	"action.scale": "Skalieren ...",
	"action.scale.desc": "Die ausgewählten Elemente skalieren",
	"action.toggle_visibility": "Sichtbarkeit umschalten",
	"action.toggle_visibility.desc": "Schaltet die Sichtbarkeit der ausgewählten Elemente um",
	"action.toggle_export": "Export umschalten",
	"action.toggle_export.desc": "Schaltet die Export-Einstellung der ausgewählten Elemente um",
	"action.toggle_autouv": "Auto-UV umschalten",
	"action.toggle_autouv.desc": "Die Auto-UV-Einstellung der ausgewählten Elemente umschalten",
	"action.toggle_shade": "Schattierung umschalten",
	"action.toggle_shade.desc": "Die Schattierung der ausgewählten Elemente umschalten",
	"action.rename": "Umbenennen",
	"action.rename.desc": "Den Namen der ausgewählten Elemente ändern",
	"action.add_display_preset": "Neues Preset",
	"action.add_display_preset.desc": "Ein neues Anzeige-Preset erstellen",
	"action.fullscreen": "Vollbild",
	"action.fullscreen.desc": "Vollbildmodus umschalten",
	"action.zoom_in": "Ansicht vergrößern",
	"action.zoom_in.desc": "Ansicht der Benutzeroberfläche vergrößern",
	"action.zoom_out": "Ansicht verkleinern",
	"action.zoom_out.desc": "Ansicht der Benutzeroberfläche verkleinern",
	"action.zoom_reset": "Ansichtsgröße zurücksetzen",
	"action.zoom_reset.desc": "Größe der Ansicht zurücksetzen",
	"action.reset_interface": "Benutzeroberfläche zurücksetzen",
	"action.reset_interface.desc": "Setzt alle Größen und Positionen der Benutzeroberfläche zurück",
	"action.screenshot_model": "Modell aufnehmen",
	"action.screenshot_model.desc": "Nimmt ein angepasstes Bildschirmfoto des Modells aus dem aktuellen Blickwinkel auf",
	"action.screenshot_app": "Programm aufnehmen",
	"action.screenshot_app.desc": "Nimmt ein Bildschirmfoto des gesamten Programms auf",
	"action.import_texture": "Textur importieren",
	"action.import_texture.desc": "Eine oder mehrere Texturen von deinem Computer öffnen",
	"action.create_texture": "Textur erstellen",
	"action.create_texture.desc": "Erstellt eine leere Textur oder ein Texturtemplate",
	"action.save_textures": "Texturen speichern",
	"action.save_textures.desc": "Speichert alle ungespeicherten Texturen",
	"action.animated_textures": "Animierte Texturen",
	"action.animated_textures.desc": "Spielt oder pausiert die Vorschau von animierten Texturen",
	"action.origin_to_geometry": "Angelpunkt zentrieren",
	"action.origin_to_geometry.desc": "Verschiebt den Angelpunkt zur Mitte der ausgewählten Elemente",
	"action.bone_reset_toggle": "Knochen zurücksetzen",
	"action.bone_reset_toggle.desc": "Verhindert, dass der Knochen Elemente des Elternmodells anzeigt",
	"action.reload": "Blockbench neu laden",
	"action.reload.desc": "Lädt Blockbench neu. Diese Aktion vernichtet alle ungespeicherten Änderungen",
	"menu.file": "Datei",
	"menu.edit": "Bearbeiten",
	"menu.transform": "Transformieren",
	"menu.display": "Anzeige",
	"menu.view": "Ansicht",
	"menu.file.new": "Neu",
	"menu.file.recent": "Zuletzt geöffnet",
	"menu.file.import": "Importieren",
	"menu.file.export": "Exportieren",
	"menu.transform.rotate": "Drehen",
	"menu.transform.flip": "Spiegeln",
	"menu.transform.center": "Zentrieren",
	"menu.transform.properties": "Eigenschaften",
	"menu.display.preset": "Preset anwenden",
	"menu.display.preset_all": "Preset überall anwenden",
	"menu.display.remove_preset": "Preset entfernen",
	"menu.view.zoom": "Zoomen",
	"menu.view.background": "Hintergrund",
	"menu.view.screenshot": "Bildschirmfoto",
	"menu.cube.color": "Kennzeichnungsfarbe",
	"menu.cube.texture": "Textur",
	"menu.cube.texture.transparent": "Transparent",
	"menu.cube.texture.blank": "Leer",
	"menu.group.sort": "Sortieren",
	"menu.texture.face": "Auf Flächen anwenden",
	"menu.texture.file": "Datei",
	"menu.texture.refresh": "Neu laden",
	"menu.texture.change": "Quelldatei ändern",
	"menu.texture.folder": "Speicherort öffnen",
	"menu.texture.edit": "Extern bearbeiten",
	"menu.texture.export": "Speichern unter",
	"menu.texture.save": "Speichern",
	"menu.texture.properties": "Eigenschaften ...",
	"menu.preview.background": "Hintergrund",
	"menu.preview.background.load": "Laden",
	"menu.preview.background.position": "Positionieren",
	"menu.preview.background.lock": "An Kamera anheften",
	"menu.preview.screenshot": "Bildschirmfoto",
	"menu.preview.perspective": "Blickwinkel",
	"menu.preview.perspective.normal": "Normal",
	"menu.preview.quadview": "Vierfachansicht",
	"menu.preview.stop_drag": "Hintergrundpositionierung beenden",
	"menu.uv.mapping.rotation": "Drehung",
	"menu.uv.texture": "Textur",
	"cube.color.light_blue": "Hellblau",
	"cube.color.yellow": "Gelb",
	"cube.color.orange": "Orange",
	"cube.color.red": "Rot",
	"cube.color.purple": "Violett",
	"cube.color.blue": "Blau",
	"cube.color.green": "Grün",
	"cube.color.lime": "Hellgrün",
	"switches.visibility": "Sichtbarkeit",
	"switches.export": "Exportieren",
	"switches.autouv": "Auto-UV",
	"panel.uv": "UV",
	"panel.display": "Anzeigeeinstellungen",
	"panel.textures": "Texturen",
	"panel.outliner": "Outliner",
	"uv_editor.title": "UV bearbeiten",
	"uv_editor.all_faces": "Alle",
	"uv_editor.no_faces": "Keine",
	"face.north": "Norden",
	"face.south": "Süden",
	"face.west": "Westen",
	"face.east": "Osten",
	"face.up": "Oben",
	"face.down": "Unten",
	"direction.north": "Norden",
	"direction.south": "Süden",
	"direction.west": "Westen",
	"direction.east": "Osten",
	"direction.top": "Oben",
	"direction.bottom": "Unten",
	"display.slot.third_right": "Dritte Person rechts",
	"display.slot.third_left": "Dritte Person links",
	"display.slot.first_right": "Erste Person rechts",
	"display.slot.first_left": "Erste Person Links",
	"display.slot.head": "Kopf",
	"display.slot.ground": "Boden",
	"display.slot.frame": "Rahmen",
	"display.slot.gui": "Inventar",
	"display.rotation": "Rotation",
	"display.translation": "Position",
	"display.scale": "Größe",
	"display.slot": "Position",
	"display.reference": "Referenzmodell",
	"display.reference.player": "Spieler",
	"display.reference.zombie": "Zombie",
	"display.reference.armor_stand": "Rüstungsständer",
	"display.reference.baby_zombie": "Zombiekind",
	"display.reference.armor_stand_small": "Kleiner Rüstungsständer",
	"display.reference.monitor": "Normal",
	"display.reference.bow": "Gespannter Bogen",
	"display.reference.block": "Block",
	"display.reference.frame": "Rahmen",
	"display.reference.inventory_nine": "3×3",
	"display.reference.inventory_full": "Inventar",
	"display.reference.hud": "Schnellzugriffsleiste",
	"display.preset.blank_name": "Bitte gib einen Namen an",
	"display.preset.item": "Standard-Gegenstand",
	"display.preset.block": "Standard-Block",
	"display.preset.handheld": "Standard-Waffe",
	"display.preset.rod": "Standard-Stab",
	"dialog.continue": "Fortfahren",
	"message.square_textures": "Texturen müssen quadratisch sein",
	"message.unsaved_texture.title": "Ungespeicherte Texturen",
	"message.unsaved_texture.message": "Alle ungespeicherten Änderungen an dieser Textur gehen dadurch verloren. Möchtest du fortfahren?",
	"action.vertex_snap_mode.move": "Verschieben",
	"action.vertex_snap_mode.scale": "Größe ändern",
	"action.open_model_folder": "Modellordner öffnen",
	"action.open_model_folder.desc": "Öffnet den Ordner, in dem das Modell gespeichert ist",
	"action.change_textures_folder": "Texturspeicherort ändern",
	"action.change_textures_folder.desc": "Verändert den Speicherort aller Texturen",
	"menu.texture.particle": "Für Partikel verwenden",
	"message.update_notification.title": "Ein Update konnte nicht automatisch installiert werden",
	"message.update_notification.message": "Eine neue Blockbench-Version ist verfügbar. Aktiviere „Automatische Updates“ in den Einstellungen, um sie herunterzuladen",
	"message.untextured": "Diese Fläche hat keine Textur",
	"dialog.toolbar_edit.title": "Werkzeugleiste anpassen",
	"keybindings.reset": "Zurücksetzen",
	"keybindings.clear": "Leeren",
	"action.cube_counter": "Projekt-Statistiken",
	"action.uv_rotation": "UV-Drehung",
	"action.uv_rotation.desc": "Drehung des UV-Mapping",
	"action.uv_grid": "UV-Raster",
	"action.uv_grid.desc": "Die Auflösung des Rasters, an das sich die UV-Auswahl heftet",
	"action.uv_grid.auto": "Auto",
	"action.uv_maximize": "UV maximieren",
	"action.uv_maximize.desc": "Platziert die gesamte Textur auf der Fläche",
	"action.uv_auto": "Auto-UV",
	"action.uv_auto.desc": "Stellt die UV-Größe dieser Fläche auf die wirkliche Größe der Fläche",
	"action.uv_rel_auto": "Relatives Auto-UV",
	"action.uv_rel_auto.desc": "Stellt die UV-Auswahl auf die wirkliche Größe und Position der Fläche",
	"action.uv_mirror_x": "UV auf X spiegeln",
	"action.uv_mirror_x.desc": "Spiegelt die UV-Auswahl dieser Fläche auf der X-Achse",
	"action.uv_mirror_y": "UV auf Y spiegeln",
	"action.uv_mirror_y.desc": "Spiegelt die UV-Auswahl dieser Fläche auf der Y-Achse",
	"action.uv_transparent": "Fläche entfernen",
	"action.uv_transparent.desc": "Macht die aktuelle Fläche transparent",
	"action.uv_reset": "Fläche zurücksetzen",
	"action.uv_reset.desc": "Setzt die aktuelle Fläche zurück",
	"action.cullface": "Cullface",
	"action.cullface.desc": "Blendet diese Fläche aus, wenn die ausgewählte Seite des Modells bedeckt ist",
	"action.auto_cullface": "Auto-Cullface",
	"action.auto_cullface.desc": "Setzt das Cullface dieser Fläche auf sich selbst",
	"action.face_tint": "Färbung",
	"action.face_tint.desc": "Aktiviert die Färben-Option dieser Fläche",
	"menu.toolbar.edit": "Anpassen",
	"menu.toolbar.reset": "Zurücksetzen",
	"uv_editor.rotated": "Gedreht",
	"uv_editor.auto_cull": "Cullface",
	"uv_editor.copied": "Fläche kopiert",
	"uv_editor.pasted": "Fläche eingefügt",
	"uv_editor.copied_x": "%0 Flächen kopiert",
	"uv_editor.reset": "Fläche zurückgesetzt",
	"uv_editor.maximized": "Maximiert",
	"uv_editor.autouv": "Auto-Größe",
	"uv_editor.mirrored": "Gespiegelt",
	"uv_editor.to_all": "Auf alle Flächen angewendet",
	"uv_editor.transparent": "Transparent gemacht",
	"uv_editor.cullface_on": "Cullface an",
	"uv_editor.cullface_off": "Cullface aus",
	"uv_editor.tint_on": "Färbung an",
	"uv_editor.tint_off": "Färbung aus",
	"action.uv_apply_all": "Auf alle Flächen anwenden",
	"action.uv_apply_all.desc": "Kopiert die Daten der aktuellen Fläche auf alle Flächen",
	"message.image_editor_missing.title": "Standard Bildbearbeitungsprogramm",
	"message.image_editor_missing.message": "Wähle die Programmdatei deines Bildbearbeitungsprogramms",
	"message.image_editor_missing.detail": "Blockbench konnte kein Bildbearbeitungsprogramm auf deinem Computer finden. Wähle die Programmdatei eines Bildbearbeitungsprogramms aus.",
	"action.update_autouv": "Auto-UV berechnen",
	"action.update_autouv.desc": "Berechnet das automatische UV-Mapping für die ausgewählten Elemente neu",
	"category.uv": "UV",
	"status_bar.saved": "Modell ist gespeichert",
	"status_bar.unsaved": "Es gibt ungespeicherte Änderungen",
	"action.move_up": "Hoch verschieben",
	"action.move_up.desc": "Verschiebt die ausgewählten Elemente relativ zur Kameraperspektive nach oben",
	"action.move_down": "Runter verschieben",
	"action.move_down.desc": "Verschiebt die ausgewählten Elemente relativ zur Kameraperspektive nach unten",
	"action.move_left": "Links verschieben",
	"action.move_left.desc": "Verschiebt die ausgewählten Elemente relativ zur Kameraperspektive nach links",
	"action.move_right": "Rechts verschieben",
	"action.move_right.desc": "Verschiebt die ausgewählten Elemente relativ zur Kameraperspektive nach rechts",
	"action.move_forth": "Nach vorne verschieben",
	"action.move_forth.desc": "Verschiebt die ausgewählten Elemente relativ zur Kameraperspektive nach vorne",
	"action.move_back": "Nach hinten verschieben",
	"action.move_back.desc": "Verschiebt die ausgewählten Elemente relativ zur Kameraperspektive nach hinten",
	"layout.color.wireframe": "Drahtgitter",
	"layout.color.wireframe.desc": "Drahtgitterlinien",
	"action.add_animation": "Animation hinzufügen",
	"action.add_animation.desc": "Fügt eine neue Animation hinzu",
	"action.load_animation_file": "Animation importieren",
	"action.load_animation_file.desc": "Öffnet eine Animationsdatei",
	"action.play_animation": "Animation abspielen",
	"action.play_animation.desc": "Spielt die ausgewählte Animation ab",
	"action.slider_keyframe_time": "Zeitpunkt",
	"action.slider_keyframe_time.desc": "Den Zeitpunkt des Keyframes verschieben",
	"timeline.rotation": "Drehung",
	"timeline.position": "Position",
	"timeline.scale": "Größe",
	"menu.keyframe.quaternion": "Quaternion",
	"panel.animations": "Animationen",
	"panel.keyframe": "Keyframe",
	"panel.keyframe.type": "Keyframe (%0)",
	"generic.delete": "Löschen",
	"generic.rename": "Umbenennen",
	"message.no_animation_selected": "Du musst zuerst eine Animation auswählen",
	"message.no_bone_selected": "Du musst zuerst einen Bone auswählen",
	"message.duplicate_groups.title": "Bone-Name doppelt",
	"message.duplicate_groups.message": "Der Name dieses Bones kommt mehrfach vor. Dies kann Probleme verursachen.",
	"action.delete_keyframes": "Keyframes löschen",
	"action.delete_keyframes.desc": "Löscht alle ausgewählten Keyframes",
	"menu.animation": "Animation",
	"menu.animation.loop": "Schleifenmodus",
	"menu.animation.override": "Überschreiben",
	"menu.animation.anim_time_update": "Updatevariable",
	"message.display_skin_model.title": "Skinmodell",
	"message.display_skin_model.message": "Wähle das Modell für diesen Skin",
	"message.display_skin_model.classic": "Klassisch",
	"message.display_skin_model.slim": "Schlank",
	"message.bone_material": "Bone-Material verändern",
	"action.slider_animation_length": "Animationslänge",
	"action.slider_animation_length.desc": "Verändert die Länge der ausgewählten Animation",
	"panel.variable_placeholders": "Variablen-Platzhalter",
	"panel.variable_placeholders.info": "Gib die Variablen der Animation an, für die du eine Vorschau brauchst, als Name=Wert",
	"status_bar.vertex_distance": "Entfernung: %0",
	"dialog.create_gif.title": "GIF aufzeichnen",
	"dialog.create_gif.length": "Länge",
	"dialog.create_gif.fps": "FPS",
	"dialog.create_gif.play": "Animation starten",
	"category.animation": "Animation",
	"action.record_model_gif": "GIF aufzeichnen ...",
	"action.record_model_gif.desc": "Zeichne ein animiertes GIF des Modells aus der aktuellen Perspektive auf",
	"display.mirror": "Spiegeln",
	"data.separator": "Trenner",
	"menu.preview.background.set_position": "Position festlegen",
	"dialog.toolbar_edit.hidden": "Ausgeblendet",
	"action.export_class_entity": "Java-Entity exportieren",
	"action.export_class_entity.desc": "Exportiert das Modell als Java-Klasse.",
	"settings.seethrough_outline": "Durchscheinende Auswahl",
	"settings.seethrough_outline.desc": "Zeige Auswahl durch Objekte hindurch an",
	"mode.edit": "Modellieren",
	"mode.paint": "Malen",
	"mode.display": "Vorschau",
	"mode.animate": "Animieren",
	"status_bar.recording_gif": "GIF wird aufgezeichnet",
	"status_bar.processing_gif": "GIF wird verarbeitet",
	"settings.backup_retain": "Sicherungskopien-Speicherdauer",
	"settings.backup_retain.desc": "Festlegen, für wie viele Tage Blockbench alte Sicherungskopien speichert",
	"action.rotate_tool": "Drehen",
	"action.rotate_tool.desc": "Werkzeug zum Auswählen und Drehen von Elementen",
	"action.fill_tool": "Farbeimer",
	"action.fill_tool.desc": "Farbeimer zum einfarbigen Ausfüllen von Oberflächen",
	"action.eraser": "Radiergummi",
	"action.eraser.desc": "Radiergummi zum Ersetzen der Farben durch Transparenz",
	"action.color_picker": "Farbpipette",
	"action.color_picker.desc": "Wählt die Farbe eines Pixels der Textur aus.",
	"switches.mirror": "UV spiegeln",
	"language_name": "Deutsch",
	"message.plugin_reload": "%0 lokale Plugins wurden neugeladen",
	"settings.brightness": "Helligkeit",
	"settings.brightness.desc": "Helligkeit der Vorschau. Standardwert ist 50",
	"menu.preview.perspective.reset": "Kamera zurücksetzen",
	"action.fill_mode": "Füllmodus",
	"action.fill_mode.face": "Fläche",
	"action.fill_mode.color": "Farbe",
	"action.toggle_mirror_uv": "UV spiegeln",
	"action.toggle_mirror_uv.desc": "UV-Mapping der ausgewählten Quader auf der X-Achse spiegeln.",
	"menu.texture.blank": "Auf leere Flächen anwenden",
	"dialog.scale.select_overflow": "Überstehendes auswählen",
	"action.action_control": "Kommandozentrale",
	"action.action_control.desc": "Suche und benutze jede verfügbare Aktion",
	"keybindings.recording": "Tastenkombination wird aufgezeichnet",
	"keybindings.press": "Drücke eine Taste bzw. Tastenkombination oder klicke auf den Bildschirm, um eine Tastenkombination aufzuzeichnen.",
	"action.pivot_tool": "Angelpunktwerkzeug",
	"action.pivot_tool.desc": "Werkzeug zum Bearbeiten des Angelpunktes",
	"action.slider_animation_speed": "Wiedergabegeschwindigkeit",
	"action.slider_animation_speed.desc": "Wiedergabegeschwindigkeit der Timeline in Prozent",
	"action.previous_keyframe": "Vorheriger Keyframe",
	"action.previous_keyframe.desc": "Springe zum vorherigen Keyframe",
	"action.next_keyframe": "Nächster Keyframe",
	"action.next_keyframe.desc": "Springe zum nächsten Keyframe",
	"message.outdated_client.title": "Version veraltet",
	"message.outdated_client.message": "Bitte update auf die neuste Version von Blockbench",
	"action.export_asset_archive": "ZIP-Ordner herunterladen",
	"action.export_asset_archive.desc": "Lädt ein Archiv mit dem Modell und allen benötigten Texturen herunter",
	"action.upload_sketchfab": "Teilen auf Sketchfab",
	"message.sketchfab.name_or_token": "Bitte gib deinen Sketchfab-Schlüssel und einen Namen ein",
	"dialog.sketchfab_uploader.title": "Modell auf Sketchfab hochladen",
	"dialog.sketchfab_uploader.token": "API-Schlüssel",
	"dialog.sketchfab_uploader.about_token": "Der Schlüssel wird benötigt, um Blockbench mit deinem Sketchfab-Account zu verbinden. Du findest ihn unter %0",
	"dialog.sketchfab_uploader.name": "Name",
	"dialog.sketchfab_uploader.description": "Beschreibung",
	"dialog.sketchfab_uploader.tags": "Tags",
	"settings.sketchfab_token": "Sketchfab-Schlüssel",
	"settings.sketchfab_token.desc": "Schlüssel, der Blockbench erlaubt, Modelle auf Sketchfab hochzuladen",
	"panel.color": "Farbauswahl",
	"data.origin": "Angelpunkt",
	"message.sketchfab.success": "Modell erfolgreich hochgeladen",
	"message.sketchfab.error": "Upload auf Sketchfab fehlgeschlagen",
	"settings.outliner_colors": "Outliner-Farben",
	"settings.outliner_colors.desc": "Farben von Elementen und Gruppen im Outliner anzeigen",
	"action.upload_sketchfab.desc": "Modell auf Sketchfab hochladen",
	"action.element_colors": "Elementfarben",
	"action.element_colors.desc": "Elementfarben im Outliner anzeigen",
	"texture.error.file": "Datei nicht gefunden",
	"texture.error.parent": "Textur durch Elternmodell",
	"message.recover_backup.title": "Projekte wiederherstellen",
	"message.recover_backup.message": "Blockbench wurde ohne zu speichern geschlossen. Möchtest du das Modell wiederherstellen?",
	"message.invalid_session.title": "Ungültiger Schlüssel",
	"message.invalid_session.message": "Die Session ist abgelaufen oder der angegebene Schlüssel ist ungültig",
	"dialog.create_texture.power": "Zweierpotenzgröße",
	"dialog.create_gif.turn": "Drehgeschwindigkeit",
	"action.edit_session": "Zusammenarbeiten ...",
	"action.edit_session.desc": "Mit einer Session verbinden, um mit anderen zusammenzuarbeiten",
	"action.reset_keyframe": "Keyframe zurücksetzen",
	"action.reset_keyframe.desc": "Alle Werte der ausgewählten Keyframes zurücksetzen",
	"dialog.edit_session.title": "Zusammenarbeiten",
	"edit_session.username": "Name",
	"edit_session.token": "Schlüssel",
	"edit_session.about": "Mit Sessions kann über das Internet zusammen an Modellen gearbeitet werden. Erstelle eine Session, kopiere den Schlüssel und schicke ihn an Freunde. Diese können damit deiner Session beitreten.",
	"edit_session.join": "Session beitreten",
	"edit_session.create": "Session erstellen",
	"edit_session.quit": "Session verlassen",
	"edit_session.joined": "%0 ist der Session beigetreten",
	"edit_session.left": "%0 hat die Session verlassen",
	"edit_session.quit_session": "Session verlassen",
	"edit_session.status": "Status",
	"edit_session.hosting": "Eine Session betreibend",
	"edit_session.connected": "Mit Session verbunden",
	"dialog.sketchfab_uploader.private": "Privat (Pro)",
	"dialog.sketchfab_uploader.password": "Passwort (Pro)",
	"action.uv_select_all": "Alle auswählen",
	"action.uv_select_all.desc": "Alle Oberflächen im UV-Dialog auswählen",
	"panel.chat": "Chat",
	"edit_session.welcome": "Willkommen in der Sitzung von %0",
	"dialog.yes": "Ja",
	"dialog.no": "Nein",
	"generic.remove": "Entfernen",
	"generic.download": "Herunterladen",
	"generic.search": "Suchen",
	"dates.today": "Heute",
	"dates.yesterday": "Gestern",
	"dates.this_week": "Diese Woche",
	"dates.weeks_ago": "Vor %0 Wochen",
	"mode.start.new": "Neu",
	"mode.start.recent": "Zuletzt verwendet",
	"format.free": "Generisches Modell",
	"format.free.desc": "Unbeschränktes Modell für Unity o.Ä.",
	"format.java_block": "Java-Item/-Block",
	"format.java_block.desc": "Blockmodell für Java Edition. Größe und Rotationen sind begrenzt.",
	"format.bedrock": "Bedrock-Entity",
	"format.bedrock.desc": "Modell für die Bedrock Edition",
	"format.bedrock_old": "Bedrock-Modell (veraltet)",
	"format.bedrock_old.desc": "Modell für Minecraft Bedrock Edition vor 1.12",
	"format.modded_entity": "Entitymodell für Mods",
	"format.modded_entity.desc": "Entitymodell für Minecraft-Mods, kann als .java-Klasse exportiert werden",
	"format.optifine_entity": "OptiFine-Entity",
	"format.optifine_entity.desc": "Entitymodell für die OptiFine-Mod",
	"keys.mouse": "Maustaste %0",
	"message.cleared_blank_faces.title": "Leere Flächen",
	"message.cleared_blank_faces.message": "Blockbench hat %0 Elemente ohne Textur gefunden. Möchtest du diese Elemente löschen?",
	"message.wireframe.enabled": "Drahtgitteransicht aktiviert",
	"message.wireframe.disabled": "Drahtgitteransicht deaktiviert",
	"dialog.convert_project.title": "Projekt konvertieren",
	"dialog.create_texture.double_use": "Mehrfachbelegung beibehalten",
	"dialog.model_stats.title": "Modellstatistiken",
	"dialog.model_stats.cubes": "Quader",
	"dialog.model_stats.locators": "Locator",
	"dialog.model_stats.groups": "Gruppen",
	"dialog.model_stats.vertices": "Eckpunkte",
	"dialog.model_stats.faces": "Flächen",
	"settings.username": "Benutzername",
	"settings.username.desc": "Benutzername für Edit Sessions",
	"settings.painting_grid": "Malgitter",
	"settings.painting_grid.desc": "Im Malmodus Gitter auf Texturen anzeigen",
	"action.convert_project": "Projekt konvertieren",
	"action.convert_project.desc": "Konvertiert das Project in ein anderes Format",
	"action.close_project": "Projekt schließen",
	"action.close_project.desc": "Schließt das momentan geöffnete Projekt",
	"action.export_bedrock": "Bedrock Modell exportieren",
	"action.export_bedrock.desc": "Exportiert das Modell als Geometry-Datei für die Bedrock Edition",
	"action.save_project": "Projekt speichern",
	"action.save_project.desc": "Speichert das Modell als Projektdatei",
	"action.save_project_as": "Projekt speichern als",
	"action.save_project_as.desc": "Speichert das Modell als Projektdatei an einem neuen Ort",
	"action.export_over": "Modell überschreiben",
	"action.export_over.desc": "Exportiert Modell, Texturen und Animationen durch Überschreiben der Dateien",
	"action.add_locator": "Locator hinzufügen",
	"action.add_locator.desc": "Fügt einen Locator hinzu, der die Position von Partikeln, Leinen usw. festlegt",
	"action.uv_turn_mapping": "UV-Auswahl drehen",
	"action.uv_turn_mapping.desc": "Dreht die UV-Auswahl um 90 Grad",
	"action.remove_blank_faces": "Leere Flächen entfernen",
	"action.remove_blank_faces.desc": "Entfernt alle ausgewählten Flächen, die keine Textur haben",
	"web.download_app": "App herunterladen",
	"uv_editor.turned": "UV gedreht",
	"display.reference.crossbow": "Gespannte Armbrust",
	"dialog.settings.search_results": "Suchergebnisse",
	"settings.animation_snap": "Keyframerate",
	"settings.animation_snap.desc": "Interval der Positionen, an denen sich Keyframes in der Timeline platzieren lassen",
	"action.import_optifine_part": "OptiFine-Part importieren",
	"action.import_optifine_part.desc": "Importiere ein Part-Modell als Teil eines OptiFine-Entity-Modells",
	"data.locator": "Locator",
	"mode.start.no_recents": "Keine zuletzt verwendeten Modelle",
	"panel.element": "Element",
	"panel.element.position": "Position",
	"panel.element.size": "Größe",
	"panel.element.origin": "Angelpunkt",
	"panel.element.rotation": "Rotation",
	"message.canvas_limit_error.title": "Begrenzungsfehler",
	"message.canvas_limit_error.message": "Die Aktion konnte nicht korrekt durchgeführt werden, weil das Format das Modell auf einen Bereich von 48 Einheiten beschränkt. Verschiebe den Angelpunkt, um das zu verhindern.",
	"data.effect": "Effekt",
	"generic.name": "Name",
	"settings.recent_projects": "Zuletzt-verwendet-Maximum",
	"settings.recent_projects.desc": "Maximale Anzahl an zuletzt verwendeten Modellen, die angezeigt werden",
	"settings.volume": "Lautstärke",
	"settings.volume.desc": "Lautstärke für Soundeffekte in Animationen",
	"action.clear_timeline": "Timeline aufräumen",
	"action.clear_timeline.desc": "Räumt alle nicht ausgewählten Animatoren aus der Timeline",
	"action.select_effect_animator": "Effekte bearbeiten",
	"action.select_effect_animator.desc": "Öffnet eine Timeline zur Bearbeitung von Sounds und Partikeln",
	"action.timeline_focus": "Kanäle filtern",
	"action.timeline_focus.desc": "Wähle den Animationskanal, der in der Timeline angezeigt wird",
	"timeline.particle": "Partikel",
	"timeline.sound": "Sound",
	"timeline.effects": "Effekte",
	"data.format": "Format",
	"format.optifine_part": "OptiFine-Part",
	"format.optifine_part.desc": "JPM-Part für OptiFine-Entitymodelle",
	"action.reverse_keyframes": "Keyframes umkehren",
	"action.reverse_keyframes.desc": "Kehrt die Reihenfolge der ausgewählten Keyframes um",
	"generic.help": "Hilfe",
	"message.removed_faces": "%0 Flächen entfernt",
	"dialog.sketchfab_uploader.draft": "Entwurf",
	"action.slider_pos": "%0-Position",
	"action.slider_pos.desc": "Elemente auf der %0-Achse verschieben",
	"action.slider_size": "%0-Größe",
	"action.slider_size.desc": "Größe auf der %0-Achse verändern",
	"action.slider_rotation": "%0-Drehung",
	"action.slider_rotation.desc": "Elemente auf der %0-Achse drehen",
	"action.slider_origin": "%0-Angelpunkt",
	"action.slider_origin.desc": "Angelpunkt auf der %0-Achse verschieben",
	"action.rotate_cw": "%0 um +90 drehen",
	"action.rotate_cw.desc": "Die ausgewählten Elemente um 90° auf der %0-Achse drehen",
	"action.rotate_ccw": "%0 um -90 drehen",
	"action.rotate_ccw.desc": "Die ausgewählten Elemente um -90° auf der %0-Achse drehen",
	"action.flip": "%0 spiegeln",
	"action.flip.desc": "Spiegelt die ausgewählten Elemente auf der %0-Achse",
	"action.center": "%0 zentrieren",
	"action.center.desc": "Zentriert die ausgewählten Elemente auf der %0-Achse",
	"action.bring_up_all_animations": "Alle veränderten Animatoren in der Timeline anzeigen",
	"panel.bone": "Bone",
	"data.color": "Farbe",
	"generic.export": "Export",
	"generic.none": "Keine",
	"status_bar.recording": "Zeitraffer wird aufgezeichnet",
	"message.add_to_palette": "Zur Palette hinzugefügt",
	"message.size_modifiers": "Halte Steuerung oder Umschalt, um Objekte in kleineren Abständen zu bewegen",
	"message.timelapse_start": "Zeitrafferaufnahme angefangen",
	"message.timelapse_stop": "Zeitrafferaufnahme beendet",
	"message.import_palette.replace_palette": "Alte Palette ersetzen",
	"message.import_palette.threshold": "Schwellenwert",
	"dialog.timelapse.interval": "Intervall (Sekunden)",
	"dialog.timelapse.source": "Quelle",
	"dialog.timelapse.source.interface": "Programm",
	"dialog.timelapse.source.locked": "Feste Perspektive",
	"dialog.timelapse.destination": "Zielordner",
	"layout.color.checkerboard": "Schachbrettmuster",
	"layout.color.checkerboard.desc": "Hintergrund von Vorschau und UV-Fenster",
	"layout.font.code": "Code-Schriftart",
	"layout.css": "Eigenes CSS",
	"settings.category.paint": "Malen",
	"settings.deactivate_size_limit": "Größenbegrenzung deaktivieren",
	"settings.deactivate_size_limit.desc": "Deaktiviert die Größenbegrenzung",
	"settings.brush_opacity_modifier": "Pinseldeckkraft-Modifikator",
	"settings.brush_opacity_modifier.desc": "Beeinflusse die Deckkraft des Pinsels bei Benutzung von einem Stylus",
	"settings.brush_size_modifier": "Pinselgröße-Modifikator",
	"settings.brush_size_modifier.desc": "Beeinflusse die Größe des Pinsels bei Benutzung von einem Stylus",
	"settings.brush_modifier.pressure": "Druck",
	"settings.brush_modifier.tilt": "Neigung",
	"category.color": "Farbe",
	"action.import_theme": "Farbschema importieren",
	"action.export_theme": "Farbschema exportieren",
	"action.export_theme.desc": "Ein Farbschema aus den aktuellen Einstellungen erstellen",
	"action.slider_color_h": "Farbton",
	"action.slider_color_s": "Sättigung",
	"action.slider_color_v": "Wert",
	"action.add_to_palette": "Zur Palette hinzufügen",
	"action.add_to_palette.desc": "Die ausgewählte Farbe zur Palette hinzufügen",
	"action.import_palette": "Palette importieren",
	"action.import_palette.desc": "Eine Farbpalette aus einer Datei importieren",
	"action.export_palette": "Palette exportieren",
	"action.export_palette.desc": "Exportiert die Palette als eine .GPL-Datei",
	"action.generate_palette": "Palette generieren ...",
	"action.generate_palette.desc": "Erstellt eine Palette aus einer Textur",
	"action.sort_palette": "Palette sortieren",
	"action.sort_palette.desc": "Sortiert alle Farben der Palette nach Farbton und Helligkeit",
	"action.timelapse": "Zeitraffer ...",
	"action.timelapse.desc": "Zeichnet eine Zeitrafferaufnahme von der Benutzung von Blockbench auf",
	"action.add_keyframe": "Keyframe hinzufügen",
	"action.add_keyframe.desc": "Fügt einen Keyframe hinzu. Halte Umschalt gedrückt, um die Werte zurückzusetzen",
	"action.bring_up_all_animations.desc": "Listet alle verwendeten Animatoren in der Timeline auf",
	"timeline.timeline": "Anweisungen",
	"menu.palette.load.default": "Standard",
	"generic.import": "Importieren",
	"settings.brush_modifier.none": "Unbelegt",
	"action.export_entity": "Bedrock-Entitymodell exportieren",
	"action.export_entity.desc": "Exportiert das Modell als ein Bedrock-Entitymodell",
	"settings.highlight_cubes": "Elemente hervorheben",
	"settings.highlight_cubes.desc": "Elemente erscheinen heller, wenn man die Maus über sie bewegt oder sie auswählt",
	"action.add_marker": "Marker setzen",
	"action.add_marker.desc": "Setzt einen Marker in der Timeline",
	"timeline.pre_effect_script": "Skript",
	"format.skin": "Minecraft Skin",
	"format.skin.desc": "Bearbeite Spielerskins und Entity-Texturen",
	"message.sketchfab.setup_guide": "Finde heraus, wie du Modelle auf Sketchfab einrichtest: %0",
	"dialog.skin.title": "Minecraft-Skin erstellen",
	"dialog.skin.model": "Modell",
	"action.toggle_skin_layer": "Zweite Skin-Schicht umschalten",
	"action.toggle_skin_layer.desc": "Aktiviert / Deaktiviert die Hut- und Kleidungsebene",
	"action.gui_light": "Inventarbeleuchtung",
	"action.gui_light.desc": "Wähle die Art der Beleuchtung des Gegenstands im Inventar",
	"action.gui_light.side": "Seitliches Licht",
	"action.gui_light.front": "Frontales Licht",
	"action.move_keyframe_back": "Keyframe zurück bewegen",
	"action.move_keyframe_forth": "Keyframe vorwärts bewegen",
	"menu.help": "Hilfe",
	"menu.help.discord": "Discord-Server",
	"menu.help.report_issue": "Einen Bug melden",
	"menu.help.plugin_documentation": "Plugin-API-Dokumentation",
	"menu.help.search_action": "Befehl suchen und ausführen",
	"menu.help.donate": "Spenden",
	"menu.help.about": "Über ...",
	"menu.preview.background.clipboard": "Aus Zwischenablage laden",
	"dialog.ignore": "Ignorieren",
	"generic.unset": "(Keine)",
	"message.invalid_builtin_parent.title": "Ungültiges Elternmodell",
	"message.invalid_builtin_parent.message": "Die Referenz auf das ungültige Elternmodell „%0“ wurde entfernt, um ein funktionierendes Modell zu speichern.",
	"dialog.resize_texture.fill": "Füllen mit",
	"dialog.resize_texture.fill.transparent": "Transparenz",
	"dialog.resize_texture.fill.color": "Farbe",
	"dialog.resize_texture.fill.repeat": "Wiederholen",
	"dialog.scale.element_pivot": "Angelpunkt",
	"dialog.scale.selection_center": "Mittelpunkt der Auswahl",
	"dialog.create_gif.length_mode": "Längenmodus",
	"dialog.create_gif.length_mode.seconds": "Sekunden",
	"dialog.create_gif.length_mode.frames": "Frames",
	"dialog.create_gif.length_mode.animation": "Animationslänge",
	"dialog.create_gif.length_mode.turntable": "Umdrehung",
	"dialog.save_angle.projection": "Projektion",
	"dialog.save_angle.projection.perspective": "Perspektivisch",
	"dialog.save_angle.projection.orthographic": "Parallel",
	"dialog.sketchfab_uploader.animations": "Animationen",
	"dialog.settings.theme": "Farbschema",
	"settings.category.interface": "Benutzeroberfläche",
	"settings.preview_checkerboard": "Vorschau-Schachbrettmuster",
	"settings.preview_checkerboard.desc": "Aktiviert das Schachbrettmuster hinter der 3D-Vorschau",
	"settings.uv_checkerboard": "UV-Fenster-Schachbrettmuster",
	"settings.uv_checkerboard.desc": "Aktiviert das Schachbrettmuster hinter dem UV-Fenster",
	"category.paint": "Malen",
	"action.fill_mode.color_connected": "Verbundene Farben",
	"action.draw_shape_type": "Form",
	"action.draw_shape_type.rectangle": "Rechteck",
	"action.draw_shape_type.rectangle_h": "Rechteck (Hohl)",
	"action.draw_shape_type.ellipse": "Ellipse",
	"action.draw_shape_type.ellipse_h": "Ellipse (Hohl)",
	"action.draw_shape_type.line": "Linie",
	"action.mirror_painting": "Gespiegelt Malen",
	"action.mirror_painting.description": "Spiegelt alle Pinselstriche auf die andere Seite des Modells",
	"action.lock_alpha": "Transparenzkanal sperren",
	"action.lock_alpha.description": "Sperrt die Transparenz aller Pixel",
	"action.draw_shape_tool": "Form zeichnen",
	"action.draw_shape_tool.desc": "Werkzeug zum Zeichnen einfacher Formen",
	"action.export_gltf": "glTF-Modell exportieren",
	"action.export_gltf.desc": "Exportiert das Modell und die Animationen als glTF-Datei, zur Weiterverwendung in anderen 3D-Programmen",
	"action.transform_space": "Transformationsraum",
	"action.transform_space.desc": "Raum, in dem Elemente bewegt werden",
	"action.transform_space.global": "Global",
	"action.transform_space.local": "Lokal",
	"action.toggle_camera_projection": "Kameraprojektion umschalten",
	"action.toggle_camera_projection.desc": "Schaltet die Kameraprojektion zwischen perspektivisch und parallel um",
	"action.load_camera_angle": "Kamerablickwinkel: %s",
	"action.load_camera_angle.desc": "Den Kamerablickwinkel „%0“ laden",
	"action.slider_face_tint": "Färbungsindex",
	"action.slider_face_tint.desc": "Legt den Färbungsindex für die ausgewählten Flächen fest. -1 entspricht keiner Färbung.",
	"menu.help.quickstart": "Schnellstartassistent",
	"menu.help.developer": "Entwickler",
	"menu.help.developer.dev_tools": "Entwicklerwerkzeuge öffnen",
	"menu.help.developer.reset_storage": "Auf Werkseinstellungen zurücksetzen",
	"menu.help.developer.reset_storage.confirm": "Bist du dir sicher, dass du Blockbench auf Werkseinstellungen zurücksetzen möchtest? Der Vorgang wird alle Benutzereinstellungen und Plugins zurücksetzen.",
	"menu.help.developer.cache_reload": "Cache neu laden",
	"menu.preview.orthographic": "Parallel",
	"menu.preview.save_angle": "Blickwinkel speichern ...",
	"menu.preview.angle": "Blickwinkel",
	"menu.preview.angle.initial": "Standardblickwinkel",
	"menu.preview.maximize": "Maximieren",
	"uv_editor.copy_selection": "Auswahl kopieren",
	"uv_editor.paste_selection": "Auswahl einfügen",
	"uv_editor.copy_paste_tool.place": "Platzieren",
	"uv_editor.copy_paste_tool.mirror_x": "Spiegeln (X)",
	"uv_editor.copy_paste_tool.mirror_y": "Spiegeln (Y)",
	"uv_editor.copy_paste_tool.rotate": "Um 90 Grad drehen",
	"dialog.project.modded_entity_version": "Exportversion",
	"dialog.save_angle.position": "Kameraposition",
	"dialog.save_angle.target": "Zielpunkt",
	"dialog.skin.pose": "Pose",
	"layout.color.frame": "Fensterrahmen",
	"layout.color.frame.desc": "Rand und Titelleiste des Fensters",
	"settings.large_grid_size": "Blockgitter-Größe",
	"settings.large_grid_size.desc": "Die Größe des Blockgitters",
	"action.load_plugin_from_url": "Plugin aus URL laden",
	"action.load_plugin_from_url.desc": "Ein Plugin von einen Server laden durch die Eingabe der URL",
	"action.cube_counter.desc": "Zeigt die aktuelle Anzahl an Elementen und andere Statistiken an",
	"action.unlock_everything": "Alle entsperren",
	"action.unlock_everything.desc": "Entsperrt alle Gruppen und Elemente im Outliner",
	"action.load_palette": "Palette laden",
	"action.load_palette.desc": "Eine der mitgelieferten oder gespeicherten Paletten laden",
	"action.toggle_locked": "Sperren/Entsperren",
	"action.toggle_locked.desc": "Sperrt oder entsperrt das Objekt",
	"action.apply_display_preset": "Vorlage anwenden",
	"action.apply_display_preset.desc": "Wendet eine Display-Settings-Vorlage an",
	"action.apply_display_preset.here": "Auf ausgewählte Position anwenden",
	"action.apply_display_preset.everywhere": "Auf alle Positionen anwenden",
	"action.resolve_keyframe_expressions": "Keyframe ausrechnen",
	"action.resolve_keyframe_expressions.desc": "Rechnet die mathematischen Ausdrücke eines Keyframes aus, um sie in Zahlen umzuwandeln",
	"action.fold_all_animations": "Alle Animatoren einklappen",
	"menu.palette.load.empty": "Leer",
	"switches.lock": "Sperren",
	"settings.render_sides": "Sichtbare Seiten",
	"settings.render_sides.desc": "Auswählen, welche Seiten einer Fläche gerendert werden",
	"settings.render_sides.auto": "Automatisch",
	"settings.render_sides.front": "Außen",
	"settings.render_sides.double": "Innen und Außen",
	"generic.enable": "Aktivieren",
	"generic.disable": "Deaktivieren",
	"generic.redacted": "Verdeckt",
	"dialog.select_texture.import_all": "Alle importieren",
	"dialog.skin.layer_template": "Äußere Texturen",
	"about.version.up_to_date": "Auf dem neusten Stand",
	"about.version.update_available": "Version %0 ist verfügbar",
	"settings.category.application": "Anwendung",
	"settings.streamer_mode": "Streamer-Modus",
	"settings.streamer_mode.desc": "Verdeckt sensible Informationen wie zuletzt verwendete Modelle",
	"settings.automatic_updates": "Automatische Updates",
	"settings.automatic_updates.desc": "Neue Versionen automatisch installieren und Blockbench auf dem neusten Stand halten",
	"action.rotation_space": "Rotationsraum",
	"action.focus_on_selection": "Ansicht auf Auswahl ausrichten",
	"action.focus_on_selection.desc": "Zentriert die Kamera auf die aktuelle Auswahl",
	"action.jump_to_timeline_start": "Zum Anfang springen",
	"action.jump_to_timeline_end": "Zum Ende springen",
	"menu.help.updating": "Aktualisiere (%0%)",
	"menu.help.update_failed": "Update fehlgeschlagen",
	"menu.animation.loop.once": "Einmalig abspielen",
	"menu.animation.loop.hold": "Letzten Frame halten",
	"menu.animation.loop.loop": "Schleife",
	"interface.streamer_mode_on": "Streamer-Modus aktiviert",
	"generic.reset": "Zurücksetzen",
	"generic.restore": "Wiederherstellen",
	"keys.mousewheel": "Mausrad",
	"message.delete_animation.title": "Animation löschen",
	"message.delete_animation.message": "Die Animation wurde aus Blockbench entfernt. Möchtest du die Animation auch aus der Datei löschen, in der sie gespeichert war?",
	"message.no_animation_to_import": "Keine Animationen zum importieren",
	"dialog.material_instances.title": "Materialien",
	"dialog.animation_import.title": "Animationen zum Import auswählen",
	"dialog.create_texture.padding": "Zwischenraum",
	"settings.fov": "Sichtfeld",
	"settings.fov.desc": "Kamera-Sichtfeld. Der Standardwert ist 45",
	"settings.minify_bbmodel": "Reduzierte Projektdateien",
	"settings.minify_bbmodel.desc": "Projektdateien werden in einer Zeile ohne Formatierung gespeichert",
	"action.edit_material_instances": "Materialien bearbeiten",
	"action.edit_material_instances.desc": "Die Materialien für Bedrock Blöcke bearbeiten",
	"action.save_all_animations": "Alle Animationen speichern",
	"action.save_all_animations.desc": "Alle im Programm geladenen Animationen speichern",
	"action.keyframe_interpolation": "Interpolation",
	"action.keyframe_interpolation.desc": "Den Interpolationsmodus der Keyframes einstellen",
	"action.keyframe_interpolation.linear": "Linear",
	"action.keyframe_interpolation.catmullrom": "Weich",
	"action.timeline_focus.hide_empty": "Nicht belegte Kanäle ausblenden",
	"menu.file.preferences": "Einstellungen",
	"menu.animation.blend_weight": "Mischwert",
	"menu.animation.save": "Speichern",
	"menu.animation.properties": "Eigenschaften ...",
	"menu.animation.file": "Datei",
	"menu.animation.snapping": "Einrastintervall",
	"menu.animation.open_location": "Speicherort öffnen",
	"panel.keyframe.add_data_point": "Datenpunkt zum Keyframe hinzufügen",
	"panel.keyframe.remove_data_point": "Datenpunkt entfernen",
	"panel.keyframe.pre": "Vorher",
	"panel.keyframe.post": "Nachher",
	"generic.all": "Alle",
	"message.small_face_dimensions.title": "Flächengröße nicht kompatibel",
	"message.small_face_dimensions.message": "Die Auswahl enthält Flächen, deren Größe weniger als eine Längeneinheit beträgt. Das Box-UV-System betrachtet alle Flächen unterhalb dieser Schwelle als 0 Pixel groß. Deshalb könnten einige Flächen nicht richtig angezeigt werden.",
	"message.small_face_dimensions.face_uv": "Das aktuelle Format unterstützt UV-Maps für einzelne Flächen. Dadurch werden kleinere Flächen unterstützt. Gehe zu „Datei“ > „Projekt ...“ und stell „UV-Modus“ auf „Flächen-UV“.",
	"dialog.plugins.outdated_client": "Setzt eine neuere Blockbench-version voraus",
	"dialog.plugins.outdated_plugin": "Plugin ist veraltet und funktioniert nicht mit dieser Version von Blockbench",
	"settings.motion_trails": "Bewegungspfade",
	"settings.motion_trails.desc": "Blendet Bewegungspfade im Animationsfenster ein",
	"settings.antialiasing": "Kantenglättung",
	"settings.antialiasing.desc": "Aktiviere Kantenglättung (Anti-Aliasing). Änderungen werden erst nach Neustarten von Blockbench aktiv",
	"action.timeline_frame_back": "Springe 1 Frame zurück",
	"action.timeline_frame_forth": "Springe 1 Frame weiter",
	"panel.bone.ik": "Inverse Kinematik (experimentell)",
	"settings.particle_tick_rate": "Partikel-Tickrate",
	"settings.particle_tick_rate.desc": "Tickrate für Partikeleffekte in Ticks pro Sekunde. Standardwert ist 30",
	"action.lock_motion_trail": "Bewegungspfad feststellen",
	"action.lock_motion_trail.desc": "Sperrt den Bewegungspfad auf die momentan ausgewählte Gruppe",
	"menu.animation_file.unload": "Entlade Animationsdatei",
	"data.null_object": "Null-Objekt",
	"status_bar.toggle_sidebar": "Seitenleiste ein-/ausblenden",
	"message.load_plugin_failed.title": "Laden des Plugins fehlgeschlagen",
	"message.load_plugin_failed.message": "Stelle sicher, dass der Name der Plugindatei mit der in Plugin.register festgelegten ID des Plugins (`%0`) übereinstimmt",
	"dialog.project.uv_mode": "UV-Modus",
	"dialog.project.uv_mode.box_uv": "Box-UV",
	"dialog.project.uv_mode.face_uv": "Flächen-UV",
	"dialog.project.texture_size": "Textur-Größe",
	"dialog.animation_export.title": "Animationen zum Export auswählen",
	"dialog.create_texture.rearrange_uv": "UV neu anordnen",
	"layout.color.subtle_text": "Untergeordneter Text",
	"layout.color.subtle_text.desc": "Zweite, weniger kontrastreiche Textfarbe",
	"settings.interface_scale": "Benutzeroberflächen Skalierung",
	"settings.interface_scale.desc": "Skalieren der gesamten Blockbench-Benutzeroberfläche",
	"settings.background_rendering": "Im Hintergrund rendern",
	"settings.background_rendering.desc": "Aktualisiert die Vorschau, während das Fenster nicht fokussiert ist",
	"settings.ctrl_shift_size": "Auflösung mit Strg + Umschalt",
	"settings.ctrl_shift_size.desc": "Auflösung des Gitters, während Strg und Umschalt gedrückt wird",
	"settings.hardware_acceleration": "Hardwarebeschleunigung",
	"settings.hardware_acceleration.desc": "Verarbeitungsaufgaben auf die Grafikkarte verlagern. Zum Anwenden der Änderungen Blockbench neustarten",
	"action.explode_skin_model": "Skin-Modell explodieren",
	"action.explode_skin_model.desc": "Schaltet eine Explosionsansicht ein, in der verdeckte Flächen bearbeitet werden können",
	"action.export_minecraft_skin": "Minecraft-Skin exportieren",
	"action.export_minecraft_skin.desc": "Minecraft-Skin als PNG-Textur exportieren",
	"action.add_null_object": "Null-Objekt hinzufügen",
	"action.add_null_object.desc": "Neues Null-Objekt hinzufügen",
	"action.animated_texture_frame": "Animierter Texturrahmen",
	"action.animated_texture_frame.desc": "Aktuelles Bild der animierten Textur einstellen",
	"action.export_animation_file": "Animationen exportieren ...",
	"action.export_animation_file.desc": "Exportiere eine Auswahl an Animationen in eine neue Datei",
	"action.timeline_graph_editor": "Graph-Editor umschalten",
	"action.timeline_graph_editor.desc": "Zeitliste zwischen Graph-Editor und Keyframe-Ansicht Umschalten",
	"menu.file.recent.clear": "Zuletzt geöffnete Dateien leeren",
	"switches.shade": "Schatten",
	"generic.share": "Teilen",
	"dates.minute": "%0 Minute",
	"dates.minutes": "%0 Minuten",
	"dates.hour": "%0 Stunde",
	"dates.hours": "%0 Stunden",
	"dates.day": "%0 Tag",
	"dates.days": "%0 Tage",
	"dates.week": "%0 Woche",
	"dates.weeks": "%0 Wochen",
	"dates.year": "%0 Jahr",
	"dates.years": "%0 Jahre",
	"message.installed_plugin": "Das Plugin %0 wurde erfolgreich installiert",
	"message.installed_plugin_fail": "Das Plugin %0 wurde aufgrund eines Fehlers nicht installiert",
	"dialog.share_model.title": "Modell teilen",
	"dialog.share_model.expire_time": "Dauer",
	"dialog.share_model.failed": "Das Hochladen des Modells ist fehlgeschlagen",
	"action.import_java_block_model": "Java/Item-Modell hinzufügen",
	"action.import_java_block_model.desc": "Ein Minecraft-Java-Block-/Item-Modell aus einer json-Datei zum aktuellen Modell hinzufügen",
	"action.share_model": "Teilen ...",
	"action.share_model.desc": "Einen kurzen Link zu Teilen generieren",
	"action.import_project": "Projekt importieren",
	"action.import_project.desc": "Importiere ein Projekt aus einer .bbmodel-Datei in das aktuelle Projekt",
	"dialog.toolbar_edit.hidden_tools": "Einige Werkzeuge werden möglicherweise nicht angezeigt, da sie im aktuellen Modus, Format oder in der Situation nicht verfügbar sind.",
	"settings.camera_near_plane": "Kamera-Abschneide-Ebene",
	"settings.camera_near_plane.desc": "Die minimale Entfernung von der Kamera und dem Renderort eines Objekts. Höhere Werte verringern Z-Fighting. 1 ist der Standardwert.",
	"mode.start.keymap_preference.desc": "Wenn du Blockbench zum ersten Mal benutzt und schon erfahren in einem anderen 3D-Programm bist, dann kannst du die Tastenbelegung dieses Programms übernehmen, um dich besser in Blockbench zurechtzufinden. Du kannst die Tastenbelegungen auch nachher in den Einstellungen ändern",
	"message.load_keymap": "Bist du dir sicher, dass du diese Tastenbelegung laden möchtest? Deine vorherigen Tastenkombinationen werden überschrieben.",
	"message.keymap_loaded": "Tastenbelegung wurde geladen",
	"dialog.convert_project.current_format": "Aktuelles Format",
	"dialog.create_texture.rearrange_uv.desc": "Eine neue UV-Anordnung anlegen, um jeder Fläche ihren eigenen Platz auf der Textur zuzuweisen",
	"dialog.create_texture.power.desc": "Die automatische Größe der generierten Textur auf eine Zweierpotenz begrenzen. Dies wird von einigen Renderingprogrammen vorausgesetzt.",
	"dialog.create_texture.double_use.desc": "Wenn zwei Elemente den gleichen Platz auf der Textur verwenden, wird dies in der neuen Anordnung beibehalten",
	"dialog.create_texture.padding.desc": "Einen kleinen Zwischenraum zwischen den einzelnen Teilen des Templates lassen",
	"dialog.create_texture.resolution.desc": "Die Basisauflösung der Textur, in Pixel pro Meter. Die wirkliche Größe der Textur hängt von der Anzahl und Größe der Elemente ab.",
	"dialog.create_gif.color": "Hintergrundfarbe",
	"dialog.save_angle.zoom": "Zoom",
	"dialog.skin.variant": "Variante",
	"dialog.flip_animation.info": "Gegenüberliegende Bones werden durch die Wörter „left“ und „right“ innerhalb ihres Namens erkannt.",
	"dialog.export_private_settings.title": "Private Einstellungen",
	"dialog.export_private_settings.message": "Deine Datei enthält die folgenden privaten Informationen: **%0**. Entferne diese Informationen, falls du die Datei mit anderen Teilen möchtest.",
	"dialog.export_private_settings.keep": "Behalten",
	"settings.timecode_frame_number": "Timecodes als Einzelbildnummer anzeigen",
	"settings.timecode_frame_number.desc": "Den Timecode in der Timeline als Nummer des Einzelbildes statt als Hundertstel Sekunde anzeigen",
	"settings.animation_sample_rate": "Sample-Rate in Animationen",
	"settings.animation_sample_rate.desc": "Sample-Rate in Samples pro Sekunde, für Kurven, die das jeweilige Exportformat nicht direkt unterstützt",
	"keybind.preview_zoom": "Ansicht zoomen",
	"action.gradient_tool": "Verlaufswerkzeug",
	"action.gradient_tool.desc": "Erstellt Farbverläufe auf Texturen",
	"action.import_settings": "Einstellungen importieren",
	"action.import_settings.desc": "Eine .bbsettings-Einstellungs-Datei importieren",
	"action.export_settings": "Einstellungen exportieren",
	"action.export_settings.desc": "Die Einstellungen von Blockbench als eine .bbsettings-Datei exportieren",
	"action.load_keymap": "Tastenbelegung importieren",
	"action.load_keymap.default": "Standard (Trackpad/Maus)",
	"action.load_keymap.mouse": "Standard (Maus)",
	"action.load_keymap.default.desc": "Standardtastenbelegungen, optimiert für Navigation im Vorschaufenster mit Laptop-Trackpads",
	"action.load_keymap.mouse.desc": "Standardtastenbelegungen, optimiert für Navigation im Vorschaufenster mit der mittleren Maustaste",
	"action.load_keymap.blender.desc": "Tastenbelegung ähnlich zu Blender",
	"action.load_keymap.cinema4d.desc": "Tastenbelegung ähnlich zu Cinema 4D",
	"action.load_keymap.maya.desc": "Tastenbelegung ähnlich zu Autodesk Maya",
	"action.import_keymap": "Tastenbelegung importieren",
	"action.import_keymap.desc": "Importiere Tastenbelegungen als .bbkeymap-Datei",
	"action.export_keymap": "Tastenbelegung exportieren",
	"action.export_keymap.desc": "Aktuelle Tastenbelegungen als .bbkeymap-Datei exportieren",
	"action.edit_history": "Bearbeitungsverlauf ...",
	"action.edit_history.desc": "Zeige den Verlauf der Bearbeitungen an und mache Schritte rückgängig oder wiederhole sie",
	"action.group_elements": "Elemente gruppieren",
	"action.group_elements.desc": "Packe ausgewählte Elemente in eine neue Gruppe",
	"action.unfold_groups": "Gruppen aufklappen",
	"action.unfold_groups.desc": "Alle Gruppen im Outliner ausklappen",
	"action.edit_bedrock_binding": "Bindung bearbeiten ...",
	"action.edit_bedrock_binding.desc": "Lege fest, an welchen Bone das Modell gebunden ist",
	"action.pick_screen_color": "Bildschirm-Farbpipette",
	"action.pick_screen_color.desc": "Eine Farbe vom Bildschirm auswählen",
	"action.view_mode": "Anzeigemodus",
	"action.view_mode.desc": "Verändert den Angeigemodus der Vorschau",
	"action.view_mode.textured": "Texturiert",
	"action.view_mode.solid": "Einfarbig",
	"action.view_mode.wireframe": "Drahtgitter",
	"action.toggle_sidebars": "Seitenleisten an-/ausschalten",
	"action.toggle_sidebars.desc": "Seitenleisten aktivieren oder deaktivieren",
	"action.set_animation_end": "Ende der Animation setzen",
	"action.set_animation_end.desc": "Setzt das Ende der ausgewählten Animation auf den aktuellen Zeitpunkt",
	"action.flip_animation": "Animation spiegeln",
	"action.flip_animation.desc": "Spiegelt teile der Animation, indem die ausgewählten Keyframes auf die andere Seite des Modells kopiert werden",
	"action.graph_editor_zero_line": "Nulllinie einschließen",
	"action.graph_editor_zero_line.desc": "Legt fest, ob die Nulllinie im Graph-Editor immer im Sichtbereich sein muss",
	"menu.texture.render_mode": "Anzeigemodus",
	"menu.texture.render_mode.emissive": "Leuchtend",
	"menu.texture.render_mode.layered": "Geschichtet",
	"menu.preview.angle.edit": "Kamerablickwinkel bearbeiten ...",
	"menu.animation.start_delay": "Start-Verzögerung",
	"menu.animation.loop_delay": "Schleifen-Verzögerung",
	"menu.animation.flip_keyframes": "Keyframes spiegeln",
	"menu.mobile_keyboard.disable_all": "Alle deaktivieren",
	"panel.keyframe.toggle_uniform_scale": "Gleichmäßige Skalierung aktivieren/deaktivieren",
	"camera_angle.common_isometric_right": "Isometrisch, rechts (2:1)",
	"camera_angle.common_isometric_left": "Isometrisch, links (2:1)",
	"camera_angle.true_isometric_right": "Isometrisch, rechts (30°)",
	"camera_angle.true_isometric_left": "Isometrisch, links (30°)",
	"menu.help.wiki": "Blockbench Wiki",
	"settings.update_to_prereleases": "Auf Vorabversionen aktualisieren",
	"settings.update_to_prereleases.desc": "Blockbench automatisch auf die neusten Vorabversionen aktualisieren, um neue Funktionen zu testen. Vorabversionen können Fehler beinhalten, aktiviere diese Funktion nicht, wenn du dich für deine Arbeit auf die einwandfreie Funktion von Blockbench verlassen musst.",
	"data.separator.spacer": "Abstandhalter",
	"data.separator.linebreak": "Zeilenumbruch",
	"data.setting": "Einstellung",
	"generic.select_all": "Alle auswählen",
	"generic.select_none": "Auswahl aufheben",
	"projects.new_tab": "Neuer Tab",
	"projects.close_tab": "Tab schließen",
	"message.invalid_format.title": "Ungültiges Format",
	"message.invalid_format.message": "Dieses Modell wurde in dem Format „%0“ erstellt. Das Format ist in dieser Blockbench-Installation nicht verfügbar. Wahrscheinlich wird ein bestimmtes Plugin zum fehlerfreien Öffnen dieser Datei benötigt.",
	"message.invalid_link": "Ungültiger oder abgelaufener Link",
	"message.default_textures.current": "Aktueller Pfad",
	"message.update_after_restart": "Das Update wird nach dem nächsten Neustart installiert.",
	"message.copy_paste_tool_viewport": "Dieses Werkzeug kann nur im UV-Editor verwendet werden",
	"dialog.project.shadow_size": "Schattengröße",
	"dialog.find_replace.target": "Ziel",
	"dialog.find_replace.target.element_names": "Namen von Elementen",
	"dialog.find_replace.target.group_names": "Namen von Gruppen",
	"dialog.find_replace.target.animation_names": "Namen von Animationen",
	"dialog.find_replace.target.keyframe_values": "Keyframe-Werte",
	"dialog.find_replace.find": "Finden",
	"dialog.find_replace.replace": "Ersetzen",
	"dialog.find_replace.regex": "Regulärer Ausdruck",
	"dialog.add_primitive.shape": "Form",
	"dialog.add_primitive.shape.circle": "Kreis",
	"dialog.add_primitive.shape.tube": "Röhre",
	"dialog.add_primitive.shape.cone": "Kegel",
	"dialog.add_primitive.shape.cylinder": "Zylinder",
	"dialog.add_primitive.shape.sphere": "Kugel",
	"dialog.add_primitive.shape.torus": "Torus",
	"dialog.add_primitive.shape.cube": "Quader",
	"dialog.add_primitive.shape.pyramid": "Pyramide",
	"dialog.add_primitive.diameter": "Durchmesser",
	"dialog.add_primitive.height": "Höhe",
	"dialog.add_primitive.sides": "Seiten",
	"dialog.add_primitive.minor_diameter": "Dicke",
	"dialog.add_primitive.minor_sides": "Kleine Seiten",
	"dialog.create_texture.combine_polys": "Flächen kombinieren",
	"dialog.create_texture.combine_polys.desc": "Koplanare Flächen in einen Bereich auf der UV-Map vereinen",
	"dialog.model_stats.meshes": "Maschen",
	"dialog.export_private_settings.omit": "Auslassen",
	"layout.select": "Auswählen",
	"layout.options": "Optionen",
	"layout.color": "Farbschema",
	"layout.documentation": "Dokumentation",
	"layout.color.bright_ui_text": "Text auf heller Oberfläche",
	"layout.color.bright_ui_text.desc": "Text auf hellen Oberflächen",
	"layout.name": "Name",
	"layout.author": "Ersteller",
	"settings.dialog.desc": "Den „%0“-Dialog anzeigen",
	"settings.export_empty_groups": "Leere Gruppen exportieren",
	"settings.export_empty_groups.desc": "Gruppen ohne Inhalt exportieren",
	"category.separators": "Trenner",
	"keybind.preview_area_select": "Bereichsauswahl",
	"action.color_erase_mode": "Löschmodus",
	"action.color_erase_mode.desc": "Im Löschmodus ziehen Werkzeuge wie der Farbeimer und das Formwerkzeug Farben ab",
	"action.open_from_link": "Modell von einem Link öffnen ...",
	"action.open_from_link.desc": "Ein Modell aus einem blckbn.ch-Link laden",
	"action.import_obj": "OBJ-Modell importieren",
	"action.import_obj.desc": "Objekte aus einem OBJ-Modell als Maschen importieren",
	"action.add_plugin": "Plugin installieren",
	"action.add_plugin.desc": "Ein Plugin mit Hilfe von Action Control installieren",
	"action.remove_plugin": "Plugin deinstallieren",
	"action.remove_plugin.desc": "Ein Plugin mit Hilfe von Action Control deinstallieren",
	"action.add_mesh": "Masche hinzufügen",
	"action.add_mesh.desc": "Fügt eine neue Masche hinzu",
	"action.add_texture_mesh": "3D-Textur hinzufügen",
	"action.add_texture_mesh.desc": "Fügt eine neue 3D-Textur hinzu",
	"action.find_replace": "Finden/Ersetzen ...",
	"action.find_replace.desc": "Teile von Namen finden und ersetzen",
	"action.hide_everything_except_selection": "Alles außer Auswahl ausblenden",
	"action.hide_everything_except_selection.desc": "Schaltet die Sichtbarkeit aller Elemente außer der momentan ausgewählten um",
	"action.transform_space.normal": "Normale",
	"action.selection_mode": "Auswahlmodus",
	"action.selection_mode.desc": "Modus, in dem Elemente in der Vorschau ausgewählt werden können",
	"action.selection_mode.object": "Objekt",
	"action.selection_mode.face": "Fläche",
	"action.selection_mode.vertex": "Punkt",
	"action.create_face": "Fläche oder Kante erstellen",
	"action.create_face.desc": "Bildet eine neue Fläche oder eine neue Kante zwischen den ausgewählten Punkten",
	"action.convert_to_mesh": "In Masche konvertieren",
	"action.convert_to_mesh.desc": "Konvertiert die ausgewählten Elemente in Maschen",
	"action.invert_face": "Fläche umkehren",
	"action.invert_face.desc": "Invertiert die ausgewählten Flächen, so dass sie in die andere Richtung zeigen",
	"action.extrude_mesh_selection": "Auswahl extrudieren",
	"action.extrude_mesh_selection.desc": "Erweitert die ausgewählten Teile der Masche",
	"action.loop_cut": "Schnitt",
	"action.loop_cut.desc": "Die Masche quer zur ausgewählten Kante durchschneiden",
	"action.merge_meshes": "Maschen zusammenführen",
	"action.merge_meshes.desc": "Vereint mehrere Maschen in eine",
	"action.keyframe_uniform": "Einheitliche Skalierung",
	"action.keyframe_uniform.desc": "Aktiviert einheitliche Skalierung der ausgewählten Keyframes",
	"menu.locator.ignore_inherited_scale": "Vererbte Größe ignorieren",
	"menu.texture.elements": "Auf Elemente anwenden",
	"uv_editor.transparent_face": "Unsichtbare Fläche",
	"display.pose_angle": "Arm-Winkel (Nur Vorschau)",
	"data.mesh": "Masche",
	"dialog.create_texture.type": "Typ",
	"dialog.create_texture.type.blank": "Leer",
	"dialog.create_texture.type.template": "Texturtemplate",
	"dialog.create_texture.type.color_map": "Farbtemplate",
	"dialog.sketchfab_uploader.suggested_tags": "Empfohlene Tags",
	"dialog.sketchfab_uploader.category": "Kategorie",
	"dialog.sketchfab_uploader.category2": "Kategorie 2",
	"layout.restore_backup": "Dein angepasstes Farbschema „%0“ wurde überschrieben. Klicke hier, um es wiederherzustellen.",
	"layout.borders": "Ränder",
	"action.fill_mode.element": "Element",
	"action.inset_mesh_selection": "Auswahl nach innen versetzen",
	"action.inset_mesh_selection.desc": "Versetzt die ausgewählten Bereiche der Masche nach innen",
	"action.dissolve_edges": "Kanten auflösen",
	"action.dissolve_edges.desc": "Löst die ausgewählten Kanten auf und vereint die angrenzenden Flächen",
	"action.split_mesh": "Masche aufteilen",
	"action.split_mesh.desc": "Trennt die ausgewählten Flächen der Masche in eine neue Masche ab",
	"action.merge_vertices": "Eckpunkte vereinen",
	"action.merge_vertices.desc": "Vereint die ausgewählten Eckpunkte",
	"action.view_mode.normal": "Flächenausrichtung",
	"action.snap_uv_to_pixels": "UV in Pixelraster einrasten",
	"action.snap_uv_to_pixels.desc": "Rastet die ausgewählten UV-Eckpunkte in das Pixelraster ein",
	"menu.file.import.import_open_project": "Importiere geöffnetes Projekt",
	"menu.help.unlock_projects": "Alle Projekte entsperren",
	"status_bar.selection.faces": "%0 Flächen",
	"status_bar.selection.vertices": "%0 Eckpunkte",
	"message.merged_vertices": "%0 Eckpunkte wurden gefunden und an %1 Stellen vereint",
	"settings.vertex_merge_distance": "Abstand für Vereinen von Eckpunkten",
	"settings.vertex_merge_distance.desc": "Abstand, in dem beieinander liegende Eckpunkte durch die Vereinen-Funktion vereint werden",
	"settings.show_only_selected_uv": "Nur ausgewählte UV-Flächen anzeigen",
	"settings.show_only_selected_uv.desc": "Zeige standardmäßig nur die aktuell ausgewählten UV-Flächen im UV-Editor an",
	"action.merge_vertices.merge_all": "Alle vereinen",
	"action.merge_vertices.merge_all_in_center": "Alle in Mittelpunkt vereinen",
	"action.merge_vertices.merge_by_distance": "Beieinander liegende vereinen",
	"action.merge_vertices.merge_by_distance_in_center": "Beieinander liegende in Mittelpunkt vereinen",
	"action.uv_rotate_left": "UV nach links drehen",
	"action.uv_rotate_left.desc": "Die ausgewählten UV-Flächen gegen den Uhrzeigersinn drehen",
	"action.uv_rotate_right": "UV nach rechts drehen",
	"action.uv_rotate_right.desc": "Die ausgewählten UV-Flächen im Uhrzeigersinn drehen",
	"menu.uv.display_uv": "UV anzeigen",
	"menu.uv.display_uv.selected_faces": "Ausgewählte Flächen",
	"menu.uv.display_uv.selected_elements": "Alle Flächen",
	"menu.uv.display_uv.all_elements": "Alle Flächen von allen Elementen",
	"menu.paste.face": "UV-Fläche",
	"menu.paste.mesh_selection": "Maschenauswahl",
	"menu.paste.outliner": "Elemente",
	"uv_editor.show_all_faces": "Alle Flächen anzeigen",
	"uv_editor.show_selected_faces": "Ausgewählte Flächen anzeigen",
	"status_bar.selection.edges": "%0 Kanten",
	"action.selection_mode.edge": "Kante",
	"message.cannot_re_import.title": "Das exportierte Modell kann nicht erneut geöffnet werden",
	"message.cannot_re_import.message": "Das exportierte Modellformat kann nicht in Blockbench geöffnet werden. Um weiterhin Zugriff auf dieses Modell zu haben, speichere es parallel als eine Projektdatei ab.",
	"generic.default": "Standard",
	"units.pixels_per_meter": "%0 Pixel pro Meter",
	"mode.pose": "Haltung",
	"modifier_actions.resize_both_sides": "Größe in beide Richtungen verändern",
	"modifier_actions.resize_one_side": "Größe in eine Richtung verändern",
	"modifier_actions.draw_line": "Linie zeichnen",
	"modifier_actions.drag_without_snapping": "Verschieben ohne Einrasten",
	"modifier_actions.stretch_keyframes": "Keyframes strecken",
	"modifier_actions.resize_background": "Hintergrund skalieren",
	"modifier_actions.select_multiple": "Mehrfachauswahl",
	"modifier_actions.select_range": "Auswahl von ... bis",
	"modifier_actions.drag_to_duplicate": "Verschieben zum Duplizieren",
	"modifier_actions.uniform_scaling": "Gleichmäßig skalieren",
	"modifier_actions.snap_direction": "Feste Ausrichtung",
	"message.no_valid_elements": "Keine gültigen Elemente ausgewählt",
	"dialog.add_primitive.shape.plane": "Ebene",
	"dialog.save_angle.rotation_mode": "Drehungsmodus",
	"dialog.save_angle.rotation": "Drehung",
	"dialog.save_angle.fov": "Sichtfeld",
	"settings.hide_tab_bar": "Tableiste automatisch verstecken",
	"settings.hide_tab_bar.desc": "Die Tableiste verstecken, wenn nur ein Tab geöffnet ist",
	"settings.status_bar_modifier_keys": "Hilfstasten in der Statusleiste vorschlagen",
	"settings.status_bar_modifier_keys.desc": "Je nach Kontext mögliche Hilfstasten-Kombinationen in der Statusleiste anzeigen",
	"settings.ground_plane": "Bodenebene",
	"settings.ground_plane.desc": "Eine Ebene als Boden unter dem Modell anzeigen",
	"settings.preview_paste_behavior": "Standardmäßiges Verhalten beim Einfügen",
	"settings.preview_paste_behavior.desc": "Wähle das Verhalten der Einfügen-Funktion, bei Verwendung in der 3D-Ansicht im Bearbeiten-Modus, wenn mehrere Optionen verfügbar sind",
	"settings.preview_paste_behavior.always_ask": "Immer nachfragen",
	"action.new_window": "Neues Fenster",
	"action.new_window.desc": "Öffnet ein neues Blockbench-Fenster",
	"action.export_collada": "Collada-Modell (dae) exportieren",
	"action.export_collada.desc": "Exportiert das Modell als dae-Datei zur Weiterverwendung in anderen 3D-Programmen",
	"action.paint_mode_uv_overlay": "UV-Hilfslinien",
	"action.paint_mode_uv_overlay.desc": "Überlagert die UV-Maps der Elemente im Malen-Modus",
	"action.bake_animation_into_model": "Animationen auf Modell anwenden",
	"action.bake_animation_into_model.desc": "Wendet die aktuell angezeigte Animation auf das Modell an. Nur Position und Drehung werden verwendet, Größe wird ignoriert",
	"action.keyframe_interpolation.step": "Stufe",
	"action.set_ik_target": "IK-Zielobjekt setzen",
	"action.set_ik_target.desc": "Wähle das Zielobjekt aus, welches durch dieses Null Objekt durch Inverse Kinematik bewegt wird",
	"menu.action_control.type.tab": "Tab",
	"menu.action_control.type.angle": "Kamerablickwinkel",
	"menu.action_control.recent_in_streamer_mode": "Bist du sicher? Streamer-Modus ist aktiviert",
	"menu.action_control.recent_in_streamer_mode.desc": "Bist du ganz sicher, dass du zuletzt verwendete Modelle anzeigen möchtest?",
	"menu.tools": "Werkzeuge",
	"menu.file.recent.more": "Mehr anzeigen ...",
	"menu.null_object.lock_ik_target_rotation": "Drehung des IK-Zielobjekts sperren",
	"menu.animation_file.import_remaining": "Verbleibende Animationen importieren",
	"edit.loop_cut.offset": "Versatz",
	"edit.extrude_mesh_selection.extend": "Größe",
	"cube.color.pink": "Pink",
	"cube.color.silver": "Silber",
	"dialog.plugins.offline": "Keine Internetverbindung",
	"dialog.create_texture.pixel_density": "Pixeldichte",
	"dialog.create_texture.pixel_density.desc": "Die Pixeldichte der Textur, in Pixel pro Meter. Die Größe der Textur kann, abhängig von der Größe und Anzahl an Elementen, abweichen.",
	"panel.skin_pose": "Haltung",
	"panel.skin_pose.none": "Keine",
	"panel.skin_pose.natural": "Natürlich",
	"panel.skin_pose.walking": "Laufend",
	"panel.skin_pose.crouching": "Schleichend",
	"panel.skin_pose.sitting": "Sitzend",
	"panel.skin_pose.jumping": "Springend",
	"panel.skin_pose.aiming": "Zielend",
	"edit.loop_cut.direction": "Ausrichtung",
	"data.texture_mesh": "3D-Textur",
	"generic.left": "Links",
	"generic.right": "Rechts",
	"mode.start.quick_setup": "Schnelle Einstellungen",
	"mode.start.keymap": "Tastenbelegung",
	"mode.start.quick_setup.more_themes": "Weitere ...",
	"dialog.resize_texture.animation_frames": "Animierte Frames",
	"dialog.export_emission_map.title": "Emission-Map exportieren",
	"dialog.export_emission_map.format": "Format",
	"dialog.export_emission_map.format.luminance": "Helligkeit",
	"dialog.export_emission_map.format.luminance_inverted": "Invertierte Helligkeit",
	"dialog.export_emission_map.format.colors": "Farben",
	"dialog.export_emission_map.threshold": "Transparenzschwellenwert",
	"dialog.export_emission_map.round_up": "Auf %0 × %1 aufrunden",
	"dialog.export_emission_map.flip_y": "Y-Achse invertieren",
	"dialog.select.type": "Element-Typ",
	"dialog.create_texture.max_edge_angle": "Maximaler Kantenwinkel",
	"dialog.create_texture.max_edge_angle.desc": "Der maximale Winkel zwischen zwei Kanten, bei dem diese verbunden werden können",
	"dialog.create_texture.max_island_angle": "Maximaler Gesamtwinkel",
	"dialog.create_texture.max_island_angle.desc": "Der maximale Winkel, mit dem Flächen zu einer UV-Insel verbunden werden können",
	"settings.mobile_panel_side": "Verankerung der Seitenleiste",
	"settings.mobile_panel_side.desc": "Wähle aus, auf welcher Seite des Bildschirms auf horizontal gehaltenen Mobilgeräten die Seitenleiste angezeigt wird",
	"settings.obj_face_export_mode": "OBJ-Flächen-Exportmodus",
	"settings.obj_face_export_mode.desc": "Stelle ein, ob alle Flächen vom OBJ-Exporter in Dreiecke oder Vierecke umgewandelt werden sollen",
	"settings.obj_face_export_mode.both": "Standard",
	"settings.obj_face_export_mode.tris": "In Dreiecke konvertieren",
	"settings.obj_face_export_mode.quads": "In Vierecke konvertieren",
	"action.seam_tool": "Nahtwerkzeug",
	"action.seam_tool.desc": "Werkeug zum Festlegen von Nähten entlang der Kanten von Maschen",
	"action.resolve_group": "Gruppe auflösen",
	"action.resolve_group.desc": "Diese Gruppe auflösen, während die Kinderelemente an der selben Stelle bleiben",
	"action.move_to_group": "In Gruppe verschieben",
	"action.move_to_group.desc": "Die Auswahl in eine bestimmte Gruppe verschieben",
	"action.select_seam": "UV-Naht auswählen",
	"action.select_seam.desc": "Den UV-Nahtmodus für die ausgewählten Kanten einstellen",
	"action.select_seam.auto": "Automatisch",
	"action.select_seam.join": "Verbunden",
	"action.select_seam.divide": "Getrennt",
	"action.adjust_brightness_contrast": "Helligkeit u. Kontrast anpassen",
	"action.adjust_brightness_contrast.desc": "Helligkeit und Kontrast der ausgewählten Textur anpassen",
	"action.adjust_saturation_hue": "Sättigung u. Farbton anpassen",
	"action.adjust_saturation_hue.desc": "Sättigung und Farbton der ausgewählten Textur anpassen",
	"action.invert_colors": "Farben umkehren",
	"action.invert_colors.desc": "Invertiert alle Farben der ausgewählten Textur",
	"action.adjust_curves": "Farbkurven anpassen ...",
	"action.adjust_curves.desc": "Verändere die Helligkeitskurve der ausgewählten Textur",
	"action.flip_texture_x": "Textur horizontal spiegeln",
	"action.flip_texture_y": "Textur vertikal spiegeln",
	"action.resize_texture": "Größe ändern ...",
	"action.view_mode.uv": "UV-Vorschau",
	"action.append_to_template": "Elemente zum Template hinzufügen...",
	"action.append_to_template.desc": "Fügt die ausgewählten Elemente zum Textur-Template hinzu",
	"action.move_texture_with_uv": "Textur gemeinsam mit UV verschieben",
	"action.move_texture_with_uv.desc": "Die Textur mitverschieben, wenn UV-Flächen verschoben werden",
	"action.timeline_setups": "Zeitleisten-Anordnungen",
	"action.save_timeline_setup": "Zeitleisten-Anordnung speichern ...",
	"action.save_timeline_setup.desc": "Speichere die aktuell ausgewählten Animatoren und Kanäle in der Zeitleiste",
	"menu.texture": "Textur",
	"menu.texture.render_mode.default": "Standard",
	"menu.texture.merge_onto_texture": "Auf Textur darüber vereinen",
	"menu.animation.unload": "Entladen",
	"panel.timeline": "Zeitleiste",
	"action.pan_tool": "Schwenktool",
	"action.pan_tool.desc": "Werkzeug zur Navigation im Textureneditor und in der 3D-Vorschau",
	"mode.start.recent.favorite": "Als Favorit kennzeichnen",
	"mode.start.info": "Info",
	"mode.start.target": "Ziel",
	"mode.start.start": "Start",
	"mode.start.create_new": "Neues Modell erstellen",
	"mode.start.format.informations": "Gut zu wissen:",
	"mode.start.format.resources": "Ressourcen:",
	"format.free.info.meshes": "In diesem Format kannst du Low-Poly-Modelle aus individuell geformten Maschen und aus Quadern erstellen.",
	"format.free.info.limitation": "Modelle können nicht in Spielen, wie zum Beispiel Minecraft, die eigene Formate voraussetzen, verwendet werden.",
	"format.skin.info.skin": "Dieses Format ist dafür vorgesehen, Minecraft-Skins und -Texturen für Kreaturen zu erstellen.",
	"format.skin.info.model": "Modelle können nicht verändert werden. Um Änderungen an einem Modell aus diesem Format vorzunehmen, konvertiere es in ein anderes Format über **Datei** > **Projekt konvertieren**.",
	"format.java_block.info.rotation": "Drehungen sind begrenzt auf Schritte von 22,5 Grad und eine Achse pro Element",
	"format.java_block.info.size": "Das Modell ist beschränkt auf eine Größe von 3 mal 3 mal 3 Blöcken. Durch Anzeigeeinstellungen können Itemmodelle jedoch weiter vergrößert werden.",
	"format.java_block.info.animation": "Dieses Format unterstützt im unmodifizierten Minecraft keine Animationen. Wenn du eine Mod erstellst, kannst du GeckoLib verwenden, um Modelle zu animieren. Anderenfalls ist die einzige Möglichkeit, das Modell zu animieren, das Auswechseln von einzelnen Modellen mit Hilfe von Befehlen oder animierten Texturen.",
	"format.bedrock.info.textures": "Jedes Modell kann nur eine einzige Textur haben",
	"format.bedrock_block": "Bedrock-Block",
	"format.bedrock_block.desc": "Blockmodell für Minecraft Bedrock Edition",
	"format.modded_entity.info.integer_size": "Die Größe einzelner Quader ist auf ganze Zahlen beschränkt.",
	"format.modded_entity.info.format": "Anstelle von Datenformaten werden Modelle als Java-Code-Dateien ausgegeben.",
	"format.optifine_entity.info.optifine_required": "Benutzer, die OptiFine nicht installiert haben, werden das Modell nicht sehen können.",
	"format.optifine_entity.info.pivots": "Die Angelpunkte der Knochen sind vom Spiel festgelegt, sollten also nicht verändert werden.",
	"format_category.low_poly": "Low-Poly",
	"format_category.minecraft": "Minecraft",
	"format_category.other": "Sonstige",
	"format_category.loaders": "Modell laden",
	"message.recover_backup.recover": "Wiederherstellen",
	"message.invalid_characters.title": "Ungültiger Dateipfad",
	"message.invalid_characters.message": "Der Dateipfad der importierten Datei beinhaltet ungültige Zeichen, Großbuchstaben, oder Leerzeichen. Gültige Zeichen sind: %0",
	"dialog.share_model.thumbnail": "Vorschaubild",
	"dialog.skin.high_res_texture": "Bitte beachte, dass die ausgewählte Auflösung nicht für normale Minecraft Skins funktioniert. Wähle eine geringere Auflösung.",
	"settings.allow_display_slot_mirror": "Spiegeln in den Anzeigeeinstellungen erlauben",
	"settings.allow_display_slot_mirror.desc": "Erlaubt es, Positionen der Anzeigeeinstellungen für Java-Block- oder Itemmodelle zu spiegeln. ACHTUNG: Spiegeln funktioniert nur in Minecraft 1.14 und früheren Versionen, oder in Sonderfällen.",
	"action.switch_tabs": "Tab wechseln",
	"action.switch_tabs.desc": "Zwischen den geöffneten Tabs wechseln. Halte Umschalt gedrückt, um die Richtung umzukehren.",
	"action.unselect_all": "Auswahl aufheben",
	"action.save_palette": "Palette zwischenspeichern",
	"action.save_palette.desc": "Die aktuelle Farbpalette in Blockbench zwischenspeichern, um später wieder auf sie zugreifen zu können",
	"action.keyframe_column_create": "Keyframes in Spalte erstellen",
	"action.keyframe_column_create.desc": "Erstellt einen Keyframe an der aktuellen Position für alle Kanäle, die bereits an anderer Stelle Keyframes haben",
	"action.keyframe_column_select": "Keyframes in Spalte auswählen",
	"action.keyframe_column_select.desc": "Wählt alle Keyframes in der Timeline unterhalb des Abspielkopfs aus",
	"menu.uv": "UV",
	"menu.keyframe": "Keyframe",
	"menu.palette.load.update": "Palette aktualisieren",
	"menu.palette.load.update.desc": "Aktualisiert diese Palette mit den Farben der aktuell geladenen Blockbench palette",
	"menu.timeline_marker.set_time": "Zeit einstellen ...",
	"uv_editor.scale_uv": "UV skalieren",
	"action.preview_scene": "Vorschauszene",
	"action.preview_scene.desc": "Die Vorschauszene auswählen",
	"preview_scene.minecraft_overworld": "Minecraft-Oberwelt",
	"preview_scene.minecraft_nether": "Minecraft-Nether",
	"preview_scene.minecraft_end": "Minecraft-Ende",
	"dialog.project.modded_entity_flip_y": "Y-Koordinaten umkehren",
	"preview_scene.studio": "Studio",
	"format.image": "Bild",
	"modifier_actions.set_copy_source": "Quelle für Kopierstempel setzen",
	"message.load_images.title": "Bilder laden",
	"message.load_images.edit_image": "Bild bearbeiten",
	"dialog.add_primitive.align_edges": "Kanten gerade ausrichten",
	"dialog.flip_animation.show_in_timeline": "Veränderte Knochen in der Timeline anzeigen",
	"settings.default_cube_size": "Quadergröße",
	"settings.default_cube_size.desc": "Die Standardgröße für neu erstellte Quader festlegen",
	"settings.uniform_keyframe": "Einheitliche Skalierkeyframes",
	"settings.uniform_keyframe.desc": "Skalierkeyframes standardmäßig auf einheitliche Skalierung einstellen",
	"settings.nearest_rectangle_select": "Rechteckauswahl: Nächste Kante",
	"settings.nearest_rectangle_select.desc": "Die Rechteckauswahl an der nächsten Kante orientieren, wie in GIMP, anstatt alle berührten Pixel auszuwählen.",
	"settings.pick_color_opacity": "Farbdeckkraft auswählen",
	"settings.pick_color_opacity.desc": "Mit der Farbpipette die Deckkraft auswählen und als Deckkraft für den Pinsel verwenden",
	"settings.paint_with_stylus_only": "Nur mit Stylus malen",
	"settings.paint_with_stylus_only.desc": "Nur den Stylus für Malwerkzeuge verwenden, die Maus oder Touchgesten für Navigation vorbehalten.",
	"action.copy_brush_mode": "Kopierstempel-Modus",
	"action.copy_brush_mode.copy": "Kopieren",
	"action.copy_brush_mode.pattern": "Muster",
	"action.copy_brush_mode.sample": "Probe",
	"action.brush_shape": "Pinselform",
	"action.brush_shape.square": "Quadrat",
	"action.brush_shape.circle": "Kreis",
	"action.blend_mode": "Mischmodus",
	"action.blend_mode.default": "Standard",
	"action.blend_mode.set_opacity": "Deckkraft setzen",
	"action.blend_mode.color": "Farbe",
	"action.blend_mode.behind": "Dahinter",
	"action.blend_mode.multiply": "Multiplizieren",
	"action.blend_mode.divide": "Dividieren",
	"action.blend_mode.add": "Addieren",
	"action.blend_mode.subtract": "Subtrahieren",
	"action.blend_mode.screen": "Bildschirm",
	"action.blend_mode.overlay": "Überlagern",
	"action.blend_mode.hard_light": "Hartes Licht",
	"action.blend_mode.difference": "Differenz",
	"action.copy_brush": "Kopierstempel",
	"action.copy_brush.desc": "Pinsel um Teile der Textur zu kopieren oder Muster zu malen",
	"action.validator_window": "Probleme anzeigen ...",
	"action.validator_window.desc": "Öffnet den Validator, welcher Probleme mit dem Projekt automatisch erkennt und auflistet.",
	"action.cancel_gif": "GIF abbrechen",
	"menu.text_edit.copy_vector": "Vektor kopieren",
	"menu.brush_presets.dialog": "Pinsel-Vorlagen ...",
	"menu.brush_presets.pixel_brush": "Pixelstift",
	"menu.brush_presets.smooth_brush": "Weicher Pinsel",
	"menu.texture.edit_in_blockbench": "In Blockbench bearbeiten",
	"menu.mirror_painting.axis": "Achse",
	"menu.mirror_painting.axis.desc": "Wählen, auf welchen Achsen Pinselstriche gespiegelt werden",
	"menu.mirror_painting.global": "Globale Symmetrie",
	"menu.mirror_painting.global.desc": "Gespiegeltes Malen im globalen Raum aktivieren",
	"menu.mirror_painting.local": "Lokale Symmetrie",
	"menu.mirror_painting.local.desc": "Gespiegeltes Malen lokal für jedes Element aktivieren",
	"menu.mirror_painting.texture_frames": "Frames von animierter Textur",
	"menu.mirror_painting.texture_frames.desc": "Pinselstriche auf jeden Frame einer animierten Textur spiegeln",
	"format.bedrock_block.info.size_limit": "Die Größe eines Blockmodells ist begrenzt auf 20 Pixel in allen Dimensionen. Die Begrenzung kann sich jedoch vom Mittelpunkt aus bis zu 7 Pixel in alle Richtungen verschieben.",
	"format.bedrock_block.info.textures": "Verschiedene Texturen können auf unterschiedliche Flächen angewendet werden, allerdings benötigt dies extra Änderungen im Behavior Pack, damit es im Spiel funktioniert.",
	"format.image.desc": "Bearbeite Bilder in 2D-Bildbearbeitungsmodus",
	"generic.delete_all": "Alle löschen",
	"message.child_model_only.open": "Elternmodell öffnen",
	"message.child_model_only.open_with_textures": "Elternmodell öffnen und Texturen übernehmen",
	"dialog.project.credit": "Erstellerkommentar",
	"dialog.convert_project.create_copy": "Kopie erstellen",
	"dialog.texture.frame_time": "Bildzeit",
	"dialog.texture.frame_time.desc": "Lege fest, wie viele Ticks jedes Einzelbild sichtbar ist. Ein Tick entspricht einem Zwanzigstel einer Sekunde.",
	"dialog.texture.frame_interpolate": "Interpolieren",
	"dialog.texture.frame_interpolate.desc": "Interpoliere zwischen Einzelbildern, indem ein Bild in das nächste überblendet wird.",
	"dialog.texture.frame_order_type": "Schleifenmodus",
	"dialog.texture.frame_order_type.loop": "Dauerschleife",
	"dialog.texture.frame_order_type.backwards": "Schleife rückwärts",
	"dialog.texture.frame_order_type.back_and_forth": "Vorwärts und Rückwärts",
	"dialog.texture.frame_order_type.custom": "Eigene Reihenfolge",
	"dialog.texture.frame_order": "Bildreihenfolge",
	"dialog.texture.frame_order.desc": "Lege eine eigene Reihenfolge für Einzelbilder fest, indem du die Indexe der Bilder auflistest. Das erste Bild hat den Index 0, das zweite 1, usw.",
	"dialog.select.mode": "Modus",
	"dialog.select.mode.new": "Neue Auswahl",
	"dialog.select.mode.add": "Zur Auswahl hinzufügen",
	"dialog.select.mode.remove": "Von Auswahl abziehen",
	"dialog.select.mode.in_selection": "Innerhalb der Auswahl auswählen",
	"dialog.predicate_overrides.model": "Modell",
	"dialog.predicate_overrides.predicates": "Bedingung",
	"dialog.predicate_overrides.variants": "Varianten",
	"dialog.predicate_overrides.start_value": "Start",
	"dialog.predicate_overrides.add_override": "Override hinzufügen",
	"dialog.predicate_overrides.add_predicate": "Bedingung hinzufügen",
	"dialog.predicate_overrides.generate_overrides": "Overrides generieren",
	"dialog.predicate_overrides.confirm_delete": "Bist du sicher, dass du alle Overrides löschen möchtest?",
	"dialog.predicate_overrides.predicate.angle": "Kompassrichtung",
	"dialog.predicate_overrides.predicate.blocking": "Ist am Blocken",
	"dialog.predicate_overrides.predicate.broken": "Ist kaputt",
	"dialog.predicate_overrides.predicate.cast": "Ist ausgeworfen",
	"dialog.predicate_overrides.predicate.cooldown": "Abklingzeit",
	"dialog.predicate_overrides.predicate.damage": "Schaden",
	"dialog.predicate_overrides.predicate.damaged": "Ist beschädigt",
	"dialog.predicate_overrides.predicate.lefthanded": "Ist linkshändig",
	"dialog.predicate_overrides.predicate.pull": "Bogenspannung",
	"dialog.predicate_overrides.predicate.pulling": "Ist gespannt",
	"dialog.predicate_overrides.predicate.charged": "Ist geladen",
	"dialog.predicate_overrides.predicate.firework": "Hat Feuerwerk",
	"dialog.predicate_overrides.predicate.throwing": "Bereit zum Werfen",
	"dialog.predicate_overrides.predicate.time": "Tageszeit",
	"dialog.predicate_overrides.predicate.custom_model_data": "Eigene Modelldaten",
	"dialog.predicate_overrides.predicate.level": "Lichtlevel",
	"dialog.predicate_overrides.predicate.filled": "Bündel-Füllstand",
	"dialog.predicate_overrides.predicate.tooting": "Wird geblasen",
	"settings.model_export_scale": "Export-Größenverhältnis",
	"settings.model_export_scale.desc": "Faktor durch den Modelle verkleinert werden, wenn sie als glTF, DAE oder FBX exportiert werden. Der Standardwert ist 16, wodurch 16 Einheiten in Blockbench einem Meter entsprechen.",
	"action.export_fbx": "FBX-Modell exportieren",
	"action.export_fbx.desc": "Exportiert das Modell aus FBX-Datei zur Weiterverwendung in anderen 3D-Programmen und Spiel-Engines",
	"action.center_lateral": "Seitlich zentrieren",
	"action.center_lateral.desc": "Zentriert das Modell auf der X- und Z-Achse",
	"action.adjust_opacity": "Deckkraft anpassen ...",
	"action.adjust_opacity.desc": "Passe die Deckkraft der ausgewählten Textur an",
	"action.rotate_texture_cw": "Im Uhrzeigersinn drehen",
	"action.rotate_texture_ccw": "Gegen den Uhrzeigersinn drehen",
	"action.predicate_overrides": "Bedingte Overrides bearbeiten ...",
	"action.predicate_overrides.desc": "Wähle andere Modelle, die dieses Modell basierend auf bestimmten Bedingungen ersetzen",
	"action.auto_set_cullfaces": "Cullfaces automatisch einstellen",
	"action.auto_set_cullfaces.desc": "Generiert automatisch Cullfaces, die Flächen verstecken, wenn diese vom benachbarten Block verdeckt werden.",
	"menu.texture.edit_externally": "Extern bearbeiten",
	"menu.mirror_painting.texture": "2D-Editor-Symmetrie",
	"menu.mirror_painting.texture.desc": "Gespiegeltes Malen im 2D-Editor aktivieren",
	"menu.animator.rotation_global": "Drehung relativ zum globalen Raum",
	"uv_editor.face_properties": "Flächeneigenschaften",
	"uv_editor.face_properties.material_instance": "Materialien",
	"uv_editor.tint.info": "Färbung kann aktiviert werden, um Minecraft mitzuteilen, dass eine Fläche für das Färben vorgesehen ist. Färbung kann im unmodifizierten Minecraft nur bei bestimmten Blöcken, wie z. B. Blättern und Redstonestaub angewendet werden, und der Wert kann nur 0 sein.",
	"uv_editor.cullface.info": "Durch aktivierte Cullfaces wird eine Fläche deaktiviert wenn neben dem Block in der ausgewählten Richtung in der Minecraftwelt ein solider Block platziert wird. Diese Technik wird verwendet, um Modelle performanter zu machen.",
	"uv_editor.material_instance.info": "Materialien können auf einen vom Benutzer festgelegten Namen eingestellt werden. Dieser Name kann in der Block-JSON-Datei im Verhaltenspaket verwendet werden, um eine bestimmte Textur oder ein Material auf die Fläche anzuwenden.",
	"display.reference.frame_invisible": "Rahmen (unsichtbar)",
	"data.settings_profile": "Profil",
	"message.display_skin.invalid_name": "Konnte keinen Minecraft-Account mit dem Namen „%0“ finden.",
	"dialog.load_plugins_from_query.title": "Plugins laden",
	"dialog.load_plugins_from_query.text": "Du hast einen Link verwendet, der einige Plugins voraussetzt. Möchtest du diese Plugins installieren?",
	"dialog.select_model.title": "Modell auswählen",
	"dialog.select_model.bones": "Knochen",
	"dialog.select_model.cubes": "Quader",
	"dialog.settings.create_profile": "Profil erstellen ...",
	"settings_profile.confirm_delete": "Bist du sicher, dass du dieses Einstellungsprofil löschen möchtest?",
	"settings_profile.condition.type.selectable": "Manuell auswählbar",
	"settings.interface_mode": "Gerätemodus",
	"settings.interface_mode.desc": "Passt die Programmoberfläche an ein bestimmtes Gerät an. Neustarten, um die Änderungen wirksam werden zu lassen",
	"settings.interface_mode.auto": "Automatisch",
	"settings.interface_mode.desktop": "Desktop",
	"settings.interface_mode.mobile": "Mobiles Gerät",
	"settings.paint_through_transparency": "Durch Transparenz hindurchmalen",
	"settings.paint_through_transparency.desc": "Die Werkzeuge können durch transparente Pixel hindurchmalen, wenn der Transparenzkanal gesperrt ist",
	"action.tab_overview": "Tab-Übersicht",
	"action.tab_overview.desc": "Zeige alle offenen Tabs als Vorschaubilder an, und springe zu einem",
	"action.slider_color_red": "Farbkanal Rot",
	"action.slider_color_green": "Farbkanal Grün",
	"action.slider_color_blue": "Farbkanal Blau",
	"action.add_animation_controller": "Animationsregler hinzufügen",
	"action.add_animation_controller.desc": "Erstellt einen leeren Animationsregler",
	"action.animation_controller_preview_mode": "Regler Vorschau",
	"action.animation_controller_preview_mode.paused": "Angehalten",
	"action.animation_controller_preview_mode.manual": "Manuelle Vorschau",
	"action.animation_controller_preview_mode.play": "Automatische Wiedergabe",
	"action.keyframe_interpolation.bezier": "Bézier",
	"action.keyframe_bezier_linked": "Béziergriffe verbinden",
	"action.keyframe_bezier_linked.desc": "Verbindet den rechten und den linken Béziergriff",
	"action.reset_keyframe_handles": "Béziergriffe zurücksetzen",
	"action.reset_keyframe_handles.desc": "Setzt die Béziergriffe auf die Ausgangspositionen zurück",
	"action.looped_animation_playback": "Endlosschleife",
	"action.looped_animation_playback.desc": "Spiele Animationen in einer Endlosschleife ab",
	"timeline.bind_to_actor": "An Wesen binden",
	"animation_controllers.select_preset": "Wähle eine Vorlage aus ...",
	"animation_controllers.state.animations": "Animationen",
	"animation_controllers.state.particles": "Partikeleffekte",
	"animation_controllers.state.sounds": "Soundeffekte",
	"animation_controllers.state.on_entry": "Beim Eintritt",
	"animation_controllers.state.on_exit": "Beim Austritt",
	"animation_controllers.state.transitions": "Übergänge",
	"animation_controllers.state.condition": "Bedingung",
	"animation_controllers.state.blend_transition": "Übergangszeit",
	"animation_controllers.state.shortest_path": "Übergang über kürzesten Weg",
	"animation_controllers.state.edit_transition": "Übergang bearbeiten",
	"menu.color_picker.picker_type": "Art des Farbwählers",
	"menu.color_picker.picker_type.square": "Eckig",
	"menu.color_picker.picker_type.wheel": "Farbrad",
	"menu.color_picker.slider_mode": "Schieberegler",
	"menu.color_picker.slider_mode.hsv": "Farbton, Sättigung, Wert",
	"menu.color_picker.slider_mode.rgb": "Rot, Grün, Blau",
	"menu.texture.render_mode.additive": "Additiv",
	"panel.color.picker_options": "Farbwähleroptionen",
	"panel.animation_controllers": "Animationsregler",
	"display.preset.armor_stand": "Boden (Rüstungsständer)",
	"data.file_path": "Dateipfad",
	"dialog.extrude.orientation": "Ausrichtung",
	"dialog.extrude.orientation.upright": "Aufrecht",
	"dialog.extrude.orientation.flat": "Liegend",
	"dialog.scale.box_uv_warning": "Das Skalieren eines Modells mit Box-UV könnte das UV-Mapping zerstören. Versuche stattdessen, das Modell auf externer Weise zu skalieren, oder in Datei > Projekt auf Flächen-UV umzustellen.",
	"dialog.create_gif.format": "Format",
	"dialog.create_gif.format.gif": "GIF",
	"dialog.create_gif.format.png_sequence": "PNG-Sequenz",
	"dialog.create_gif.pixelate": "Verpixeln",
	"dialog.create_gif.bg_image": "Hintergrundbild",
	"dialog.create_gif.turn.desc": "Drehe das Modell während der Aufnahme. Verwende negative Zahlen, um das Modell im Uhrzeigersinn zu drehen. Der Wert 60 entspricht einer Umdrehung pro Sekunde.",
	"settings_profile.condition": "Bedingung",
	"settings_profile.condition.type.file_path.desc": "Verwende reguläre Ausdrücke, die im Dateipfad des Projekts enthalten sein müssen, um das Profil zu aktivieren. Verwende Schrägstriche als Trennzeichen",
	"settings.only_selected_bezier_handles": "Nur ausgewählte Beziergriffe anzeigen",
	"settings.only_selected_bezier_handles.desc": "Verstecke die Beziergriffe von Keyframes, die nicht ausgewählt sind",
	"settings.embed_textures": "Texturen einbetten",
	"settings.embed_textures.desc": "Bette den Inhalt von Texturen in die .bbmodel-Datei ein",
	"action.selection_mode.cluster": "Zusammenhängend",
	"dialog.copied_to_clipboard": "In Zwischenablage kopiert",
	"data.reference_image": "Referenzbild",
	"message.delete_reference_image": "Bist du sicher, dass du dieses Referenzbild löschen möchtest? Dies kann nicht rückgängig gemacht werden.",
	"message.add_reference_image.message": "Wähle, wo das Referenzbild geladen wird",
	"message.add_reference_image.project": "Zu diesem Projekt hinzufügen",
	"message.add_reference_image.app": "Zu allen Projekten hinzufügen",
	"message.import_particle_texture.import": "Partikeltextur importieren",
	"message.import_particle_texture.message": "Möchtest du eine Textur für diesen Partikeleffekt laden?",
	"message.save_codec_selector.title": "Speicherformat",
	"message.save_codec_selector.message": "Wähle ein Format, in dem das Modell gespeichert werden soll.",
	"message.save_codec_selector.project_file": "Blockbench-Projekt (.bbmodel)",
	"message.save_codec_selector.both": "Beides",
	"message.display_skin.username": "Benutzername (Java)",
	"message.palette_locked": "Die Palette ist gesperrt",
	"dialog.project.default_uv_mode": "Standard-UV-Modus",
	"dialog.project.default_uv_mode.description": "Standard-UV-Modus des Projekts. Der UV-Modus kann auch für jeden Quader einzeln eingestellt werden.",
	"dialog.export_options.title": "Exportoptionen",
	"dialog.edit_texture.preview": "Vorschau",
	"dialog.proportional_editing.range": "Reichweite",
	"dialog.proportional_editing.falloff": "Abnahme",
	"dialog.proportional_editing.falloff.linear": "Linear",
	"dialog.proportional_editing.falloff.hermite_spline": "Sanft",
	"dialog.proportional_editing.falloff.constant": "Konstant",
	"dialog.proportional_editing.selection": "Auswahl",
	"dialog.proportional_editing.selection.linear": "Lineare Entfernung",
	"dialog.proportional_editing.selection.connections": "Verbindungen",
	"dialog.mirror_painting_texture_center.middle": "Mitte",
	"dialog.mirror_painting_texture_center.custom": "Eigener Punkt",
	"dialog.settings.reset_to_default": "Auf Standardwert zurücksetzen",
	"keybindings.item.num_slider.increase": "Erhöhen",
	"keybindings.item.num_slider.decrease": "Verringern",
	"settings.always_show_splash_art": "Startbild immer anzeigen",
	"settings.always_show_splash_art.desc": "Zeige das Bild auf dem Startbildschirm bei jedem Start an",
	"action.slider_palette_color": "Farbe in Palette wechseln",
	"action.slider_palette_color.desc": "Wechsle zwischen verschiedenen Farben in der Palette",
	"action.proportional_editing": "Proportional bearbeiten",
	"action.proportional_editing.desc": "Proportional Eckpunkte um die Auswahl herum mitbewegen, wenn Teile einer Masche bearbeitet werden",
	"action.limit_to_palette": "Auf Palette begrenzen",
	"action.limit_to_palette.desc": "Begrenzt die Farben auf der Texture auf die Farben in der aktuell geladenen Palette",
	"action.edit_reference_images": "Referenzbilder bearbeiten",
	"action.edit_reference_images.desc": "Aktiviere den Referenzbildmodus, um Referenzbilder hinzuzufügen oder zu bearbeiten",
	"action.add_reference_image": "Referenzbild hinzufügen",
	"action.reference_image_from_clipboard": "Referenzbild aus Zwischenablage laden",
	"action.reference_image_list": "Referenzbilder",
	"action.connect_uv_faces": "UV-Flächen verbinden",
	"action.connect_uv_faces.desc": "Verbinde die gewählte UV-Fläche mit der davor gewählten Fläche",
	"action.merge_uv_vertices": "UV-Eckpunkte zusammenführen",
	"action.merge_uv_vertices.desc": "Führt die zuerst gewählten Eckpunkte mit den davor gewählten Eckpunkten zusammen",
	"action.bedrock_animation_mode": "Bedrock Animations-Modus",
	"action.bedrock_animation_mode.desc": "Wähle einen Modus, in dem Bedrock-Animationen bearbeitet werden können",
	"action.bedrock_animation_mode.entity": "Objekt",
	"action.bedrock_animation_mode.attachable_first": "Gegenstand, erste Person",
	"action.bedrock_animation_mode.attachable_third": "Gegenstand, dritte Person",
	"timeline.amplify": "Verstärken",
	"menu.options": "Optionen ...",
	"menu.palette.lock_palette": "Palette sperren",
	"menu.uv.export": "UV-Maps exportieren",
	"menu.uv.flip_x": "X spiegeln",
	"menu.uv.flip_y": "Y spiegeln",
	"menu.mirror_painting.enabled": "Aktiviert",
	"reference_image.position": "Position",
	"reference_image.size": "Größe",
	"reference_image.rotation": "Drehung",
	"reference_image.opacity": "Deckkraft",
	"reference_image.visibility": "Sichtbarkeit",
	"reference_image.clear_mode": "Klarsichtmodus",
	"reference_image.layer": "Ebene",
	"reference_image.layer.background": "Hinter Modell",
	"reference_image.layer.viewport": "Vor Modell",
	"reference_image.layer.float": "Vor Oberfläche",
	"reference_image.scope": "Bereich",
	"reference_image.scope.project": "Nur dieses Projekt",
	"reference_image.scope.global": "Alle Projekte",
	"reference_image.enabled_modes": "Aktiviert in Modi",
	"codec.common.encoding": "Kodierung",
	"codec.common.armature": "Gruppen als Skelett exportieren",
	"codec.common.export_animations": "Animationen exportieren",
	"codec.common.embed_textures": "Texturen einbetten",
	"preview.center_camera": "Kamera zentrieren",
	"display.reference.frame_top": "Rahmen oben",
	"display.reference.frame_top_invisible": "Rahmen oben (unsichtbar)",
	"action.proportional_editing_range": "Proportional bearbeiten: Reichweite",
	"action.proportional_editing_range.desc": "Stelle die Reichweite für das proportionale Bearbeiten ein",
	"action.toggle_all_reference_images": "Zeige/Verberge alle Referenzbilder",
	"action.toggle_all_reference_images.desc": "Aktiviere oder deaktiviere die Sichtbarkeit aller Referenzbilder auf einmal",
	"action.add_animation_controller_state": "Zustand zu Animationsregler hinzufügen",
	"action.add_animation_controller_state.desc": "Fügt einen neuen Zustand zum Animationsregler hinzu",
	"menu.slider.round_value": "Wert runden",
	"texture.error.too_large": "Auslösung übersteigt das Maximum von %0",
	"dialog.copy_to_clipboard": "In Zwischenablage kopieren",
	"dialog.open_url": "Link öffnen",
	"reference_image.image": "Bild",
	"uv_editor.rotate_uv": "UV drehen",
	"generic.error": "Fehler",
	"projects.start_screen": "Startbildschirm",
	"message.invalid_link.message": "Das geteilte Modell unter dem Link „%0“ ist entweder ungültig oder abgelaufen.",
	"message.plugin_dependencies.title": "Plugin-Abhängigkeiten",
	"message.plugin_dependencies.message1": "Das Plugin setzt folgende installierten Plugins voraus:",
	"message.plugin_dependencies.message1_update": "Das Plugin %0 wurde aktualisiert und setzt nun diese installierten Plugins voraus:",
	"message.plugin_dependencies.message2": "Möchtest du diese installieren, um fortzufahren?",
	"message.plugin_dependencies.invalid": "Leider kann das Plugin nicht installiert werden, da es von einem anderen Plugin abhängt, das nicht installiert werden kann:",
	"message.preview_scene_load_failed": "Vorschauszene konnte nicht geladen werden. Stell sicher, dass du mit dem Internet verbunden bist.",
	"dialog.convert_project.text1": "Konvertiere das Projekt in ein anderes Format.",
	"dialog.convert_project.text2": "Benutzung auf eigene Gefahr. Formate haben unterschiedliche Funktionen und Beschränkungen, deshalb wird das Konvertieren in einigen Fällen Teile des Projekts beeinflussen oder zerstören.",
	"dialog.convert_project.text3": "Konvertieren kann nicht rückgängig gemacht werden, deshalb wird eine Kopie des Projekts in einem neuen Tab erstellt.",
	"dialog.unsaved_work.title": "Ungespeicherte Änderungen",
	"dialog.unsaved_work.text": "Die folgenden Projekte beinhalten ungespeicherte Änderungen. Möchtest du die Änderungen speichern?",
	"dialog.unsaved_work.discard_all": "Alle verwerfen",
	"dialog.unsaved_work.save_all": "Alle speichern",
	"dialog.resize_texture.mode": "Modus",
	"dialog.resize_texture.mode.crop": "Zuschneiden/Erweitern",
	"dialog.resize_texture.mode.scale": "Skalieren",
	"dialog.plugins.is_installed": "Installiert",
	"dialog.plugins.is_disabled": "Deaktiviert",
	"dialog.plugins.disable": "Deaktivieren",
	"dialog.plugins.enable": "Aktivieren",
	"dialog.plugins.dependencies": "Benötigt außerdem:",
	"dialog.view_backups.open_folder": "Ordner öffnen",
	"dialog.share_model.reference_images": "Referenzbilder übernehmen",
	"dialog.share_model.too_large": "Fehler beim Hochladen: Modell ist zu groß",
	"dialog.share_model.too_large_references": "Fehler beim Hochladen: Modell ist zu groß. Versuche es erneut ohne Referenzbilder.",
	"settings.stretch_linked": "Strecken verbinden",
	"settings.stretch_linked.desc": "Strecke Quader in alle Richtungen um den gleichen Wert",
	"settings.grids": "Gitter anzeigen",
	"settings.grids.desc": "Zeige oder verstecke alle Hilfsgitter",
	"settings.double_click_switch_tools": "Bei Doppelklick zwischen Werkzeugen wechseln",
	"settings.double_click_switch_tools.desc": "Doppelklicken in der Vorschau wechselt zwischen Werkzeugen hin und her",
	"settings.outlines_in_paint_mode": "Auswahlumrisse im Malmodus anzeigen",
	"settings.outlines_in_paint_mode.desc": "Umrisse der ausgewählten Elemente im Malmodus anzeigen",
	"settings.json_indentation": "JSON-Einrückung",
	"settings.json_indentation.desc": "Einrückstil der exportierten JSON-Dateien",
	"settings.json_indentation.tabs": "Tabs",
	"settings.json_indentation.spaces_4": "Leerzeichen: 4",
	"settings.json_indentation.spaces_2": "Leerzeichen: 2",
	"action.slider_stretch": "Strecken",
	"action.slider_stretch.desc": "Strecke Quader um einen Faktor auf der %0-Achse, ohne das UV zu beeinflussen",
	"action.view_backups": "Sicherheitskopien anzeigen",
	"action.view_backups.desc": "Durchsuche die Liste der automatisch gespeicherten Sicherheitskopien",
	"action.search_outliner": "Outliner durchsuchen",
	"action.search_outliner.desc": "Suche nach Elementen mit bestimmten Namen im Outliner",
	"action.mirror_modeling": "Gespiegeltes Modellieren",
	"action.mirror_modeling.desc": "Gespiegeltes Modellieren auf der X-Achse aktivieren. Alle Änderungen werden auf die gegenüberliegenden Seite gespiegelt, außer dies ist für das betroffene Element deaktiviert.",
	"action.allow_element_mirror_modeling": "Gespiegeltes Modellieren erlauben",
	"action.allow_element_mirror_modeling.desc": "Wähle, ob die gewählten Elemente durch gespiegeltes Modellieren beeinflusst werden",
	"action.switch_face_crease": "Falz ändern",
	"action.switch_face_crease.desc": "Ändere die Ausrichtung der Falz, die das Viereck in der Mitte halbiert",
	"action.clear_unused_texture_space": "Ungenutzten Platz der Textur löschen",
	"action.clear_unused_texture_space.desc": "Löscht die Teile der Textur, die nicht von Elementen verwendet werden",
	"action.split_screen": "Geteilter Bildschirm",
	"action.split_screen.desc": "Teile den Bildschirm in mehrere Fenster ein",
	"action.split_screen.single": "Einfach",
	"action.split_screen.double_horizontal": "Doppelt horizontal",
	"action.split_screen.double_vertical": "Doppelt vertikal",
	"action.split_screen.quad": "Vierfach",
	"action.split_screen.triple_left": "Dreifach links",
	"action.split_screen.triple_right": "Dreifach rechts",
	"action.split_screen.triple_top": "Dreifach oben",
	"action.split_screen.triple_bottom": "Dreifach unten",
	"action.uv_project_from_view": "UV von Ansicht projizieren",
	"action.uv_project_from_view.desc": "Generiere UVs für die ausgewählten Flächen von der Perspektive der 3D-Vorschau",
	"action.graph_editor_other_graphs": "Andere Graphen anzeigen",
	"action.graph_editor_other_graphs.desc": "Zeige die Kurven der Achsen an, die nicht ausgewählt sind",
	"action.graph_editor_include_other_graphs": "Andere Graphen in Ansicht einbeziehen",
	"action.graph_editor_include_other_graphs.desc": "Wähle, ob nicht ausgewählte Graphen für die Größe der Darstellung berücksichtigt werden",
	"action.set_ik_source": "IK-Basis setzen",
	"action.set_ik_source.desc": "Wähle den Basisknochen der Kette, die durch Inverse Kinematik gesteuert werden soll",
	"edit.loop_cut.cuts": "Schnitte",
	"panel.element.stretch": "Strecken",
	"preview_scene.minecraft_plains": "Ebene",
	"preview_scene.minecraft_cherry_grove": "Kirschberghain",
	"preview_scene.minecraft_snowy_tundra": "Verschneite Ebene",
	"preview_scene.minecraft_sunset": "Sonnenuntergang",
	"preview_scene.minecraft_night": "Nacht",
	"preview_scene.minecraft_desert": "Wüste",
	"preview_scene.minecraft_underwater": "Unterwasser",
	"preview_scene.minecraft_coral_reef": "Korallenriff",
	"preview_scene.minecraft_lush_cave": "Üppige Höhle",
	"preview_scene.minecraft_deep_dark": "Tiefes Dunkel",
	"generic.navigate_forward": "Weiter",
	"generic.navigate_back": "Zurück",
	"action.element_render_order": "Rendering-Reihenfolge",
	"action.element_render_order.default": "Auto",
	"action.element_render_order.behind": "Hinter",
	"action.element_render_order.in_front": "Vor",
	"message.installing_update.title": "Update verfügbar",
	"message.installing_update.message": "Eine neue Version ist zur Installation bereit. Nachdem du das Programm geschlossen hast, warte bitte etwa %0 Sekunden, bevor du Blockbench erneut öffnest oder den Computer ausschaltest, damit das Update installiert werden kann.",
	"settings.brush_cursor_2d": "2D-Pinselumriss",
	"settings.brush_cursor_2d.desc": "Zeige den Umriss um den Pinselcursor im 2D-Editor an",
	"settings.brush_cursor_3d": "3D-Pinselumriss",
	"settings.brush_cursor_3d.desc": "Zeige den Umriss um den Pinselcursor in der 3D-Vorschau an",
	"settings.cdn_mirror": "CDN-Mirror verwenden",
	"settings.cdn_mirror.desc": "Den CDN-Mirror verwenden, um auf Plugins zuzugreifen. Der Mirror erhält Plugin-Updates schneller und funktioniert in Regionen, in denen das CDN sonst nicht funktioniert.",
	"data.layer": "Ebene",
	"data.panel": "Panel",
	"generic.confirm_delete": "Bist du sicher, dass du es löschen möchtest?",
	"format_category.general": "Allgemein",
	"modifier_actions.no_uniform_scaling": "Freies Seitenverhältnis",
	"message.texture_refresh_conflict.title": "Abweichende Versionen der Textur",
	"message.texture_refresh_conflict.message": "Die Texturdatei kann Veränderungen beinhalten, die von der Version in Blockbench abweichen",
	"message.texture_refresh_conflict.keep_ours": "Blockbenchs Version behalten",
	"message.texture_refresh_conflict.keep_theirs": "Datei laden und alle Änderungen und Ebenen in Blockbench verwerfen",
	"message.group_required_to_animate": "Diese Art von Element kann nicht animiert werden. Erstelle stattdessen eine Gruppe.",
	"dialog.texture.uv_size": "UV-Größe",
	"dialog.advanced_screenshot.angle_preset": "Kamerablickwinkel",
	"dialog.advanced_screenshot.resolution": "Auflösung",
	"dialog.advanced_screenshot.zoom_to_fit": "Passend zoomen",
	"dialog.advanced_screenshot.zoom": "Zoom / Brennweite",
	"dialog.advanced_screenshot.anti_aliasing": "Kantenglättung",
	"dialog.advanced_screenshot.anti_aliasing.off": "Aus",
	"dialog.advanced_screenshot.anti_aliasing.msaa": "Multisampling",
	"dialog.advanced_screenshot.anti_aliasing.ssaa": "Supersampling",
	"dialog.advanced_screenshot.show_gizmos": "Bearbeitungswerkzeuge zeigen",
	"dialog.advanced_screenshot.shading": "Schattierung",
	"settings.auto_keyframe": "Automatisch Keyframes erzeugen",
	"settings.auto_keyframe.desc": "Automatisch am Beginn der Timeline einen Keyframe mit Standardwerten erstellen, wenn an einem späteren Punkt in der Timeline animiert wird",
	"settings.modded_entity_integer_size": "Mod-Entitymodell-Größe in ganzen Zahlen",
	"settings.modded_entity_integer_size.desc": "Die Größe von Quadern auf ganze Zahlen beschränken. Obwohl Kommastellen technisch gesehen in manchen Versionen unterstützt werden, sind ganze Zahlen in der Praxis im UV-Mapping einfacher zu handhaben.",
	"category.layers": "Ebenen",
	"keybind.paint_secondary_color": "Mit Zweitfarbe malen",
	"action.selection_tool_operation_mode": "Auswahlmodus",
	"action.selection_tool_operation_mode.create": "Neue Auswahl",
	"action.selection_tool_operation_mode.add": "Hinzufügen",
	"action.selection_tool_operation_mode.subtract": "Abziehen",
	"action.selection_tool_operation_mode.intersect": "Überschneidung",
	"action.pixel_perfect_drawing": "Pixelperfektes Zeichnen",
	"action.pixel_perfect_drawing.desc": "Zeichne glatte Pixel-Art Linien ohne doppelte Pixel in Kurven",
	"action.selection_tool": "Auswahlwerkzeug",
	"action.selection_tool.desc": "Wähle Teile des Bildes aus",
	"action.selection_tool.rectangle": "Rechteck",
	"action.selection_tool.ellipse": "Ellipse",
	"action.selection_tool.lasso": "Lassowerkzeug",
	"action.selection_tool.wand": "Zauberstab",
	"action.selection_tool.color": "Gleiche Farbe",
	"action.move_layer_tool": "Ebene verschieben",
	"action.move_layer_tool.desc": "Verschiebe die ausgewählte Ebene oder Auswahl",
	"action.export_modded_animations": "Animationen für Mod-Entity exportieren",
	"action.export_modded_animations.desc": "Exportiere Animationen für ein animiertes Entity in einer Mod für Minecraft Java Edition",
	"action.swap_colors": "Farben tauschen",
	"action.swap_colors.desc": "Tausche die Hauptfarbe mit der zweiten Farbe",
	"action.apply_mesh_rotation": "Drehung anwenden",
	"action.apply_mesh_rotation.desc": "Wende die Objektdrehung auf die Masche an und setze den Wert der Drehung auf Null zurück",
	"action.flip_texture_x.desc": "Die Textur oder Ebene horizontal spiegeln",
	"action.flip_texture_y.desc": "Die Textur oder Ebene vertikal spiegeln",
	"action.rotate_texture_cw.desc": "Die Textur oder Ebene im Uhrzeigersinn drehen",
	"action.rotate_texture_ccw.desc": "Die Textur oder Ebene gegen den Uhrzeigersinn drehen",
	"action.crop_texture_to_selection": "Textur auf Auswahl zuschneiden",
	"action.create_empty_layer": "Leere Ebene erstellen",
	"action.enable_texture_layers": "Ebenen aktivieren",
	"action.disable_texture_layers": "Ebenen deaktivieren",
	"action.layer_opacity": "Ebenendeckkraft",
	"action.layer_to_texture_size": "Ebene auf Texturgröße ausweiten",
	"action.layer_to_texture_size.desc": "Weitet die Ebene auf die Größe der Textur aus",
	"action.merge_layer_down": "Nach unten vereinen",
	"action.merge_layer_down.desc": "Auf die darunterliegende Ebene vereinen",
	"action.advanced_screenshot": "Erweitertes Bildschirmfoto ...",
	"action.advanced_screenshot.desc": "Mache ein Bildschirmfoto mit erweiterten Optionen",
	"action.bake_ik_animation": "Inverse Kinematik ausrechnen und anwenden",
	"action.bake_ik_animation.desc": "Rechne die Drehungen durch Inverse Kinematik aus und wende sie aus Keyframes auf die gewählte Animation an",
	"action.save_animation_preset": "Animationsvorlage speichern ...",
	"action.save_animation_preset.desc": "Speichere die ausgewählten Keyframes als Animationsvorlage",
	"action.animation_onion_skin": "Animationszwiebelschalen",
	"action.animation_onion_skin.desc": "Zeige die Vorschau eines anderen Standbildes der Animation als Gitternetz an",
	"action.apply_animation_preset": "Animationsvorlage anwenden",
	"action.apply_animation_preset.desc": "Wähle aus einer Liste von Animationsvorlagen und wende die Vorlage auf den ausgewählten Knochen an",
	"menu.brush_presets.pixel_perfect": "Pixelgenauer Pinsel",
	"panel.layers": "Ebenen",
	"uv_editor.copy_paste_tool.to_layer": "Zu neuer Ebene",
	"format.image.new": "Neues Bild erstellen",
	"format.image.info.summary": "Mit dem 2D-Bildbearbeitungsmodus kannst du Bilder und Pixelart direkt in Blockbench erstellen und bearbeiten, ohne dass du ein externes Programm verwenden musst. Bearbeite Bilder, verändere Texturen, oder erstelle deine eigenen Pixelgrafiken!",
	"settings.move_with_selection_tool": "Auswahlwerkzeug verwenden, um Auswahl zu verschieben",
	"settings.move_with_selection_tool.desc": "Verwende das Auswahlwerkzeug direkt, um die Auswahl zu verschieben, ohne dass du zum Verschiebewerkzeug wechseln musst",
	"settings.final_newline": "Neue Zeile am Ende",
	"settings.final_newline.desc": "Füge einen Zeilenumbruch am Ende von exportierten Dateien an",
	"action.crop_layer_to_selection": "Ebene auf Auswahl zuschneiden",
	"action.edit_mode_uv_overlay.desc": "Überlagert die UV-Maps der Elemente im Bearbeitungsmodus",
	"menu.image": "Bild",
	"menu.texture.discard_changes": "Änderungen verwerfen",
	"menu.texture.discard_changes.desc": "Verwerfe alle ungespeicherten Änderungen und lade die neuste Version von der Datei",
	"panel.textures.images": "Bilder",
	"dialog.advanced": "Erweitert",
	"dialog.recommended_option": "empfohlen",
	"modifier_actions.snap_to_center": "Mittig einrasten",
	"modifier_actions.snap_to_pixels": "An Pixeln ausrichten",
	"message.invalid_format.install_plugin": "Plugin '%0' installieren",
	"message.plugin_deprecated.message": "Bist du dir sicher, dass du dieses veraltete Plugin installieren möchtest?",
	"message.plugin_deprecated.install_anyway": "Trotzdem installieren",
	"message.image_editor.not_found": "Das ausgewählte Bildbearbeitungsprogramm konnte nicht gefunden werden. Bitte wähle eine andere Option.",
	"message.knife_tool.confirm": "Drücke %0 oder klicke hier, um das Messerwerkzeug anzuwenden",
	"message.knife_tool.skipped_face": "Kann nicht zwischen unterschiedlichen Flächen schneiden. Bitte schließe die Kante oder den Eckpunkt zwischen den Flächen mit ein!",
	"message.optimize_animation.keyframes_removed": "%0 redundante Keyframes wurden entfernt",
	"message.optimize_animation.nothing_to_optimize": "Keine Möglichkeiten zur Optimierung gefunden!",
	"message.duplicate_bone_copy_animation.title": "Animation kopieren",
	"message.duplicate_bone_copy_animation.message": "Der duplizierte Knochen ist in %0 Animationen animiert. Möchtest du die Keyframes auf den neuen Knochen kopieren?",
	"message.auto_fix_mesh_edit.title": "Automatische Reparatur",
	"message.auto_fix_mesh_edit.revert": "Rückgängig machen",
	"message.auto_fix_mesh_edit.overlapping_vertices": "Einige Eckpunkte wurden in die selbe Position verschoben. Wie möchtest du vorgehen?",
	"message.auto_fix_mesh_edit.concave_quads": "Ein oder mehrere viereckige Flächen sind nun konkav. Das kann Fehler beim UV Mapping und beim Darstellen verursachen. Blockbench kann dies automatisch für dich beheben:",
	"message.auto_fix_mesh_edit.merge_vertices": "Eckpunkte vereinen",
	"message.auto_fix_mesh_edit.split_quads": "Vierecke teilen",
	"message.load_images.add_image": "Bild hinzufügen",
	"dialog.project.modded_entity_entity_class": "Entity Klasse",
	"dialog.resize_texture.offset": "Versatz",
	"dialog.animated_texture_editor.code_reference": "Code Beispiel",
	"dialog.animated_texture_editor.code_reference.about": "Dieser Code zur Implementierung der animierten Textur wurde als Beispiel generiert, und funktioniert nicht unbedingt ohne weitere Veränderungen. Lies die Dokumentation, um mehr zu erfahren.",
	"dialog.animated_texture_editor.code_reference.docs": "Dokumentation",
	"dialog.animated_texture_editor.reframe": "Neu unterteilen",
	"dialog.animated_texture_editor.stride": "Bildgröße",
	"dialog.animated_texture_editor.frames": "Anzahl der Einzelbilder",
	"dialog.animated_texture_editor.add_frame": "Einzelbild hinzufügen",
	"dialog.animated_texture_editor.resize_frames": "Bildgröße ändern...",
	"dialog.animated_texture_editor.apply": "Anwenden",
	"dialog.add_primitive.edge_size": "Kantenbreite",
	"dialog.change_animation_speed.speed": "Geschwindigkeit",
	"dialog.change_animation_speed.adjust_snapping": "Einrastintervall anpassen",
	"dialog.optimize_animation.selection": "Auswahl",
	"dialog.optimize_animation.selection.selected_keyframes": "Ausgewählte Keyframes",
	"dialog.optimize_animation.selection.selected_animation": "Ausgewählte Animation",
	"dialog.optimize_animation.selection.all_animations": "Alle Animationen",
	"dialog.optimize_animation.thresholds": "Grenzwert",
	"dialog.import_obj.obj": "OBJ Datei",
	"dialog.import_obj.mtl": "MTL Datei",
	"dialog.import_obj.scale": "Größe",
	"layout.thumbnail": "Vorschaubild CSS",
	"settings.pixel_grid": "Pixelgitter",
	"settings.pixel_grid.desc": "Im Bearbeitungsmodus ein Gitter auf den Texturen anzeigen",
	"settings.image_editor_grid_size": "Gittergröße im Bildbearbeitungsmodus",
	"settings.image_editor_grid_size.desc": "Größe des großen Gitters im Bildbearbeitungsmodus",
	"settings.ground_plane_double_side": "Doppelseitige Bodenebene",
	"settings.ground_plane_double_side.desc": "Macht die Bodenebene von unten sichtbar",
	"settings.optifine_save_default_texture": "OptiFine JEM: Ausgewählte Texture Exportieren",
	"settings.optifine_save_default_texture.desc": "Exportiere die ausgewählte Textur als Standardtextur für das Modell",
	"action.slider_color_select_threshold": "Farbauswahl Schwellenwert",
	"action.slider_color_select_threshold.desc": "Wie ähnlich die Farbe benachbarter Pixel sein muss, um vom Zauberstab oder Farb-Auswahlwerkzeug ausgewählt zu werden",
	"action.stretch_tool": "Strecken",
	"action.stretch_tool.desc": "Werkzeug zum Strecken von Elementen",
	"action.knife_tool": "Messerwerkzeug",
	"action.knife_tool.desc": "Werkzeug zum Schneiden von Maschenflächen in kleinere Segmente",
	"action.duplicate_project": "Projekt duplizieren",
	"action.duplicate_project.desc": "Erstelle eine Kopie des geöffneten Projekts",
	"action.transform_space.parent": "Übergeordnet",
	"action.transform_pivot_space": "Angelpunkt Transformationsraum",
	"action.solidify_mesh_selection": "Flächen solide machen",
	"action.solidify_mesh_selection.desc": "Verwandle die ausgewählten Flächen einer Masche in ein solides Objekt mit Dicke",
	"action.animated_texture_editor": "Animierte Textur...",
	"action.animated_texture_editor.desc": "Erstelle oder bearbeite die Daumenkino-Animation der ausgewählten Textur",
	"action.center_individual_pivots": "Individuelle Angelpunkte zentrieren",
	"action.center_individual_pivots.desc": "Verschiebt den Angelpunkt jedes einzelnen ausgewählten Elements in dessen Mitte",
	"action.uv_cycle": "UV Punkte durchrotieren",
	"action.uv_cycle.desc": "Rotiere die Anordnung der UV Eckpunkte durch, ohne die Positionen zu verändern",
	"action.uv_cycle_invert": "UV Punkte durchtauschen",
	"action.uv_cycle_invert.desc": "Kehre die Anordnung der UV Eckpunkte um, ohne die Positionen zu verändern",
	"action.slider_animation_controller_speed": "Regler Wiedergabegeschwindigkeit",
	"action.slider_animation_controller_speed.desc": "Die Wiedergabegeschwindigkeit des Animationsreglers in Prozent",
	"action.optimize_animation": "Animation optimieren",
	"action.optimize_animation.desc": "Optimiere die ausgewählte Animation und reduziere die Anzahl der Keyframes",
	"action.change_animation_speed": "Animationsgeschwindigkeit verändern...",
	"action.change_animation_speed.desc": "Verändere die Geschwindigkeit der ausgewählten Animation",
	"timeline.select_particle_file": "Partikeldatei auswählen",
	"timeline.select_sound_file": "Audiodatei auswählen",
	"menu.cube.texture.default": "Standard",
	"menu.texture.particle.clear": "Nicht mehr für Partikel verwenden",
	"menu.texture.use_as_default": "Als Standard festlegen",
	"menu.texture.use_as_default.clear": "Zuweisung als Standard aufheben",
	"menu.toolbar.overflow": "Überlauf der Werkzeugleiste",
	"edit.solidify_mesh_selection.thickness": "Dicke",
	"reference_image.sync_to_timeline": "Mit der Zeitleiste synchronisieren",
	"reference_image.toggle_playback": "Abspielen/Pausieren",
	"dialog.add_primitive.shape.beveled_cuboid": "Abgeschrägter Quader",
	"dialog.ignore_all": "Alle ignorieren",
	"data.texture_group": "Texturengruppe",
	"data.animation": "Animation",
	"generic.on": "An",
	"generic.off": "Aus",
	"format.free.info.3d_printing": "3D Druck",
	"message.invalid_file.merge_conflict": "Diese Datei beinhaltet ungelöste Git Merge-Konflikte.",
	"dialog.expand_texture_selection.radius": "Wert",
	"dialog.expand_texture_selection.corner": "Form der Ecken",
	"dialog.expand_texture_selection.corner.round": "Rund",
	"dialog.expand_texture_selection.corner.square": "Eckig",
	"dialog.expand_texture_selection.corner.manhattan": "Manhattan",
	"dialog.merge_animation.merge_target": "Zusammenführen mit",
	"keybindings.variation_conflict": "Die Tastenbelegung der Variation kollidiert mit der Haupt Tastenbelegung",
	"settings.recovery_save_interval": "Speicherintervall für Wiederherstellungspunkte",
	"settings.recovery_save_interval.desc": "Blockbench speichert das offene Project un regelmäßigen Zeitabständen, um es im Fall eines Computerabsturzes wiederherstellen zu können. Wähle den Intervall in Sekunden. Wähle 0 um das Speichern zu deaktivieren.",
	"settings.save_view_per_tab": "Ansicht per Tab speichern",
	"settings.save_view_per_tab.desc": "Speichere die aktuelle Ansicht für jeden Tab einzeln",
	"settings.inherit_parent_color": "Übergeordnete Farbe übernehmen",
	"settings.inherit_parent_color.desc": "Übernehme bei neu erstellten Elementen die Kennzeichnungsfarbe der übergeordneten Gruppe, statt eine zufällig ausgewählte Farbe zu verwenden",
	"keybind.preview_select.multi_select": "Mehrfachauswahl",
	"keybind.preview_select.group_select": "Gruppenauswahl",
	"keybind.preview_select.loop_select": "Ringauswahl",
	"action.fill_mode.selection": "Auswahl",
	"action.fill_mode.selected_elements": "Ausgewählte Elemente",
	"action.image_tiled_view": "Kachelansicht",
	"action.image_tiled_view.description": "Die sich wiederholende Kachelansicht im 2D Editor aktivieren",
	"action.image_onion_skin_view": "Zwiebelschalenansicht in Bildbearbeitung",
	"action.image_onion_skin_view.description": "Zwiebelschalenansicht im 2D Bildbearbeitungsfenster aktivieren",
	"action.expand_texture_selection": "Texturauswahl erweitern",
	"action.expand_texture_selection.desc": "Die Texturauswahl erweitern oder verkleinern",
	"action.switch_tabs.reverse_order": "Umgekehrte Reihenfolge",
	"action.save_project_incremental": "Speichern mit nächster Versionsnummer",
	"action.save_project_incremental.desc": "Speichere das Modell als eine Projektdatei mit der nächsthöheren Versionsnummer (z. B. projekt_2.bbmodel)",
	"action.copy.multiple": "Alle kopieren",
	"action.copy.multiple.desc": "Alle verfügbaren Daten individuell kopieren",
	"action.paste.multiple": "Alle einfügen",
	"action.randomize_marker_colors": "Kennzeichnungsfarben zufällig vergeben",
	"action.cube_light_emission": "Lichtemission",
	"action.cube_light_emission.desc": "Wähle die Helligkeit der ausgewählten Quader mit einem Wert zwischen 0 und 15",
	"action.view_mode.colored_solid": "Kennzeichnungsfarben",
	"action.focus_on_selection.rotate_only": "Nur drehen",
	"action.create_texture_group": "Texturengruppe erstellen",
	"action.create_texture_group.desc": "Erstelle eine Texturengruppe",
	"action.uv_maximize.all_faces": "Auf alle Flächen anwenden",
	"action.retarget_animators": "Animationen neu belegen",
	"action.retarget_animators.desc": "Lege fest, welcher Animator welche Gruppen oder Elemente animiert",
	"action.merge_animation": "Animationen zusammenführen",
	"action.merge_animation.desc": "Führe die Animation mit einer anderen Animation zusammen",
	"action.add_keyframe.reset_values": "Mit Standardwerten",
	"action.set_timeline_range_start": "Wiedergabebereich Start setzen",
	"action.set_timeline_range_start.desc": "Setze den Startpunkt für den Wiedergabebereich in der Animationszeitleiste",
	"action.set_timeline_range_end": "Wiedergabebereich Ende setzen",
	"action.set_timeline_range_end.desc": "Setze den Endpunkt für den Wiedergabebereich in der Animationszeitleiste",
	"action.disable_timeline_range": "Wiedergabebereich deaktivieren",
	"action.disable_timeline_range.desc": "Deaktiviere den Wiedergabebereich in der Animationszeitleiste",
	"menu.texture_group.resolve": "Auflösen",
	"menu.image_tiled_view.mirrored": "Gespiegelt",
	"menu.image_onion_skin_view.frame": "Einzelbilder",
	"menu.image_onion_skin_view.frame.last_viewed": "Letzter angesehener Frame",
	"menu.image_onion_skin_view.frame.previous": "Voriger Frame",
	"menu.image_onion_skin_view.frame.next": "Nächster Frame",
	"menu.image_onion_skin_view.frame.both": "Voriger + Nächster",
	"menu.image_onion_skin_view.display": "Anzeige",
	"menu.image_onion_skin_view.display.pixels": "Kleinere Pixel",
	"menu.image_onion_skin_view.display.transparent": "Transparent",
	"menu.image_onion_skin_view.above": "Darüber anzeigen",
	"menu.animation.reload": "Neu laden",
	"switches.autouv.alt": "Relativ",
	"display.rotation_pivot": "Angelpunkt für Drehung",
	"display.scale_pivot": "Angelpunkt für Skalierung",
	"display.reference.fox": "Fuchs",
	"display.reference.eating": "Ess Animation",
	"preview_scene.sky": "Himmel",
	"preview_scene.space": "Weltraum",
	"preview_scene.minecraft_ocean": "Ozean",
	"message.import_palette.selection_only": "Auf Auswahl beschränken",
	"dialog.blend_transition_edit.ease_in_out": "Weicher Übergang (%0)",
	"dialog.blend_transition_edit.generate": "Generieren...",
	"dialog.blend_transition_edit.generate.learn_more": "Mehr Infos und Vorschau",
	"dialog.blend_transition_edit.generate.curve": "Kurvenform",
	"dialog.blend_transition_edit.generate.steps": "Keyframes",
	"settings.fps_limit": "FPS Limit",
	"settings.fps_limit.desc": "Lege eine Obergrenze für die Bildwiederholrate fest. Die tatsächliche Bildwiederholrate hängt von deinem Gerät ab.",
	"settings.outliner_reveal_on_select": "Ausgewählte Elemente aufdecken",
	"settings.outliner_reveal_on_select.desc": "Zeige Elemente im Outliner wenn diese ausgewählt werden",
	"settings.java_export_pivots": "Angelpunkte in Java Block/Item-Modellen exportieren",
	"settings.java_export_pivots.desc": "Speichere Angelpunkte von Quadern ohne Drehung in Java Block/Item-Modellen",
	"animation_controllers.state.blend_transition_curve": "Übergangskurve",
	"menu.slider.reset_vector": "Vektor zurücksetzen",
	"dialog.blend_transition_edit.extended": "Erweiterter Graph",
	"message.screenshot_too_large.title": "Problem mit der Auflösung",
	"message.screenshot_too_large.message": "Das Bildschirmfoto konnte nicht korrekt aufgezeichnet werden. Versuche es mit einer geringeren Auflösung oder ohne Supersampling.",
	"message.rename_elements.numbering": "Verwende Sonderzeichen, um eine Zahlenfolge zu generieren: % wird ersetzt durch den Index des Elements in dessen Gruppe, $ wird ersetzt durch den Index des Elements in der Auswahl.",
	"generic.edit_externally": "Extern bearbeiten",
	"message.settings_require_restart.title": "Neustart erforderlich",
	"message.settings_require_restart.message": "Einige Einstellungen treten erst nach einem Neustart des Programms in Effekt.",
	"message.settings_require_restart.restart_now": "Jetzt neu starten",
	"message.settings_require_restart.restart_later": "Später neu starten",
	"message.classroom_mode.install_plugin": "Plugins können im Klassenzimmermodus nicht installiert werden",
	"dialog.collection.export_path": "Exportpfad",
	"dialog.collection.select_all": "Alle auswählen",
	"dialog.collection.select_none": "Auswahl aufheben",
	"dialog.collection.add_with_filter": "Mit Filter hinzufügen",
	"dialog.collection.remove": "Entfernen",
	"dialog.material_config.title": "Materialkonfiguration",
	"dialog.material_config.color_value": "Farbwert",
	"dialog.material_config.mer": "Metallhaftigkeit-Emissivität-Rauheit",
	"dialog.material_config.mer_value": "MER Wert",
	"dialog.material_config.depth_type": "Art der Tiefe",
	"dialog.create_texture.disable_mirror_uv": "UV Spiegelung deaktivieren",
	"dialog.create_texture.disable_mirror_uv.desc": "Deaktiviert die UV Spiegelung im Gespiegelten Modellieren, um separate UV Maps auf jeder Seite des Modells zu bewahren",
	"dialog.create_gif.turn.sync_to_anim_length": "Mit Länge der Animation abstimmen",
	"settings.category.controls": "Steuerung",
	"settings.classroom_mode": "Klassenzimmermodus",
	"settings.classroom_mode.desc": "Schränkt Funktionen wie das Installieren von Plugins ein und entfernt Links zu Sozialen Medien",
	"settings.antialiasing_bleed_fix": "Kantenglättungsartefakte reduzieren",
	"settings.antialiasing_bleed_fix.desc": "Vermeidet Artefakte durch das Übertreten von Texturen die durch Kantenglättung entstehen",
	"settings.tone_mapping": "Tonemapping",
	"settings.tone_mapping.desc": "Annäherungsmethode für die Darstellung von hohem Dynamikumfang auf einem normalen Bildschirm für PBR Effekte.",
	"settings.audio_scrubbing": "Audiovorschau bei Timelinenavigation",
	"settings.audio_scrubbing.desc": "Spielt während des Bewegens auf der Timeline kurze Audioschnipsel zur Vorschau ab",
	"settings.viewport_rotate_speed": "Rotationsgeschwindigkeit bei Navigation",
	"settings.viewport_rotate_speed.desc": "Empfindlichkeit der Steuerung zur Drehung bei der Navigation im Vorschaufenster",
	"settings.viewport_zoom_speed": "Zoomgeschwindigkeit bei Navigation",
	"settings.viewport_zoom_speed.desc": "Empfindlichkeit der Steuerung zum Zoomen bei der Navigation im Vorschaufenster",
	"settings.editor_2d_zoom_speed": "2D Editor Zoomgeschwindigkeit",
	"settings.editor_2d_zoom_speed.desc": "Empfindlichkeit der Steuerung beim Zoomen im UV bzw. 2D Editor",
	"category.select": "Auswahl",
	"action.vertex_snap_mode.rotate": "Drehen",
	"action.export_image": "Bild exportieren",
	"action.export_image.desc": "Exportiere Texturen als Bilddatei",
	"action.apply_mirror_modeling": "Gespiegeltes Modellieren anwenden",
	"action.apply_mirror_modeling.desc": "Gespiegeltes Modellieren auf die ausgewählten Elemente anwenden. Die Elemente werden kopiert und auf die andere Seite der X-Achse gespiegelt.",
	"action.create_collection": "Sammlung erstellen",
	"action.create_collection.desc": "Erstelle eine Sammlung aus den ausgewählten Elementen",
	"action.set_collection_content_to_selection": "Auswahl als Sammlungsinhalt festlegen",
	"action.set_collection_content_to_selection.desc": "Lege die ausgewählten Gruppen und Elemente als Inhalt der Sammlung fest",
	"action.add_to_collection": "Auswahl zur Sammlung hinzufügen",
	"action.add_to_collection.desc": "Füge die ausgewählten Gruppen und Elemente zur Sammlung hinzu",
	"action.view_mode.material": "Materialvorschau",
	"action.create_material": "Material erstellen",
	"action.create_material.desc": "Erstelle ein neues PBR Material aus der ausgewählten Textur",
	"action.generate_pbr_map": "PBR Map generieren...",
	"action.generate_pbr_map.desc": "Generiere eine PBR Map (Höhenmap, oder Metallhaftigkeit, Emissivität, Rauheit) aus einer bestehenden Textur",
	"menu.tools.main_tools": "Werkzeugkiste",
	"menu.view.panels": "Panele",
	"menu.texture.pbr_channel": "PBR Kanal",
	"menu.texture.pbr_channel.color": "Farbe",
	"menu.texture.pbr_channel.normal": "Normale",
	"menu.texture.pbr_channel.height": "Höhe",
	"menu.texture.pbr_channel.mer": "MER (Metall-Emission-Rauheit)",
	"menu.texture.pbr_channel.mer_subsurface": "MER Verdeckte Lichtstreuung",
	"menu.collection.export_project": "Projekt exportieren",
	"menu.collection.export_as": "Exportieren als \"%0\"",
	"menu.panel.enable": "Aktivieren",
	"menu.panel.move_to": "Verschieben",
	"menu.panel.move_to.left_bar": "Linke Seitenleiste",
	"menu.panel.move_to.right_bar": "Rechte Seitenleiste",
	"menu.panel.move_to.top": "Oben",
	"menu.panel.move_to.bottom": "Unten",
	"menu.panel.move_to.float": "Freischwebend",
	"menu.panel.move_to.hidden": "Verstecken",
	"menu.panel.fold": "Einklappen",
	"menu.mirror_painting.texture_center": "Mittelpunkt",
	"menu.mirror_modeling.mirror_uv": "UV Spiegeln",
	"menu.animation_onion_skin.frames": "Standbilder",
	"menu.animation_onion_skin.select": "Auswahl",
	"menu.animation_onion_skin.previous": "Voriger Frame",
	"menu.animation_onion_skin.next": "Nächster Frame",
	"menu.animation_onion_skin.previous_next": "Voriger + Nächster",
	"menu.animation_onion_skin.count": "Anzahl",
	"menu.animation_onion_skin.interval": "Intervall",
	"menu.animation_onion_skin_selective": "Nur Auswahl",
	"menu.animation_onion_skin_selective.desc": "Die Zwiebelschalenansicht nur für die ausgewählten Elemente des Modells aktivieren",
	"edit.loop_cut.unit": "Einheit",
	"edit.loop_cut.unit.size_units": "Größeneinheit",
	"edit.loop_cut.unit.percent": "Prozent",
	"edit.extrude_mesh_selection.direction": "Richtung",
	"edit.extrude_mesh_selection.direction.outwards": "Nach Außen",
	"edit.extrude_mesh_selection.direction.average": "Durchschnitt",
	"edit.extrude_mesh_selection.even_extend": "Gleichmäßig",
	"edit.vertex_snap.align": "Ausrichtung",
	"edit.vertex_snap.align.longest": "Längste Achse",
	"edit.vertex_snap.align.direction": "Richtung vom Angelpunkt",
	"edit.vertex_snap.align.align_axis": "%0-Achse",
	"edit.vertex_snap.ignore_axis": "Achse ignorieren",
	"codec.common.format": "Format",
	"codec.image.quality": "Qualität",
	"panel.collections": "Sammlungen",
	"modifier_actions.always": "Immer aktiv",
	"modifier_actions.unless": "Immer außer %0",
	"settings.undo_selections": "Auswahl rückgängig machen",
	"settings.undo_selections.desc": "Auswahlveränderungen im Bearbeitungsverlauf speichern und bei Bedarf rückgängig machen",
	"action.focus_on_selection.zoom": "Größe einpassen",
	"display.reference.tooting": "Bockshorn beim Abspielen",
	"settings.selection_tolerance": "Auswahltoleranz",
	"settings.selection_tolerance.desc": "Größe des Bereichs der zur Auswahl eines Eckpunktes oder einer Kante angeklickt werden kann",
	"action.delete.keep_vertices": "Kanten/Eckpunkte behalten",
	"menu.mesh": "Masche",
	"dialog.material_config.subsurface": "Volumenstreuung",
	"dialog.material_config.subsurface_enabled.desc": "Verwende den Transparenzkanal der MER Map für Volumenstreuung",
	"settings.pick_combined_color": "Farbkombination auswählen",
	"settings.pick_combined_color.desc": "Mit der Farbpipette die kombinierte Farbe aller Ebenen auswählen, an Stelle von der Farbe der ausgewählten Ebene",
	"action.split_rgb_into_layers": "RGB Farbkanäle in Ebenen aufteilen",
	"action.split_rgb_into_layers.desc": "Teile die Textur in eine additive Ebene pro RGB Farbkanal auf",
	"dialog.project.java_block_version": "Format-Version",
	"data.spline_mesh": "Spline",
	"data.billboard": "Billboard",
	"data.armature": "Skelett",
	"data.armature_bone": "Knochen",
	"generic.reload": "Neu Laden",
	"modifier_actions.subtract": "Abziehen",
	"modifier_actions.reduced_intensity": "Feinschliff",
	"modifier_actions.select_bone": "Knochen auswählen",
	"modifier_actions.spline_select_multiple_points": "Mehrere Punkte oder Griffe auswählen",
	"modifier_actions.move_panel_without_docking": "Bewegen ohne andocken",
	"message.save_all_textures.message": "Willst du die folgenden Texturen speichern?",
	"message.save_all_textures.skip": "Überspringen",
	"dialog.add_spline.shape": "Form",
	"dialog.add_spline.shape.segment": "Segment",
	"dialog.add_spline.shape.square": "Dreieck",
	"dialog.add_spline.shape.circle": "Kreis",
	"dialog.add_spline.diameter": "Durchmesser",
	"dialog.add_spline.sides_tubular": "Rohrsegmente",
	"dialog.add_spline.sides_radial": "Ring Segmente",
	"dialog.add_spline.radius": "Rohrradius",
	"dialog.add_spline.length": "Länge",
	"dialog.add_spline.width": "Breite",
	"dialog.plugins.revoke_permissions": "Berechtigungen widerrufen",
	"dialog.expression_editor.pretty_print": "Formatieren",
	"dialog.expression_editor.minify": "Minifizieren",
	"dialog.expression_editor.find_replace": "Finden/Ersetzen",
	"dialog.create_gif.show_gizmos": "Gizmos und Raster aufzeichnen",
	"dialog.preview_options.title": "Vorschau-Optionen",
	"dialog.preview_options.background": "Hintergrund",
	"dialog.preview_options.background.checkerboard": "Schachbrett-Muster",
	"dialog.preview_options.background.solid": "Solide",
	"dialog.preview_options.background.custom_color": "Benutzerdefinierte Farbe",
	"dialog.preview_options.show_gizmos": "Gizmos anzeigen",
	"dialog.skin.texture_source": "Textur-Quelle",
	"dialog.skin.texture_source.template": "Vorlage generieren",
	"dialog.skin.texture_source.load_texture": "Von Minecraft laden",
	"dialog.skin.texture_file": "Textur Datei",
	"dialog.convert_skin.adjust_texture": "Textur anpassen",
	"dialog.settings.clear_profile_value": "Wert in Profil löschen",
	"layout.section.customize": "Anpassen",
	"layout.theme.configure": "Konfigurieren",
	"layout.color.elevated": "Erhöht",
	"layout.color.elevated.desc": "Angehobene UI-Elemente, in der Regel durch einen Schatten vom Hintergrund abgehoben",
	"layout.file.watch_changes": "Zeige Änderungen und lade neu",
	"settings.autocomplete_code": "Autovervollständigung",
	"settings.autocomplete_code.desc": "Vorschläge zur Autovervollständigung in Code-Editoren anzeigen",
	"settings.detect_flipbook_textures": "Animierte Texturen erkennen",
	"settings.detect_flipbook_textures.desc": "Automatisch animierte Texturen erkennen und diese mit Animation anzeigen",
	"settings.double_click_select_reference": "Referenzbilder per Doppelklick auswählen",
	"settings.double_click_select_reference.desc": "Doppelklick in der Vorschau wählt Referenzbilder aus",
	"settings.default_keyframe_interpolation": "Standard-Keyframeinterpolation",
	"settings.default_keyframe_interpolation.desc": "Der voreingestellte Interpolationsmodus für neue Keyframes",
	"settings.color_picker_style": "Art des Farbwählers",
	"settings.color_picker_style.desc": "Wähle das Design des Farbwählers im Malmodus",
	"settings.export_asset_paths": "Pfade für Assets exportieren",
	"settings.export_asset_paths.desc": "Stelle ein, wie Pfade zu Assets wie Texturen oder Animationen in .bbmodel Dateien gespeichert werden",
	"settings.export_asset_paths.relative": "Relative Pfade",
	"settings.export_asset_paths.absolute": "Ganze Pfade",
	"settings.export_asset_paths.both": "Relative und ganze Pfade (nur Texturen)",
	"settings.export_asset_paths.none": "Nicht speichern",
	"action.slider_spline_resolution": "Spline-Auflösung %0",
	"action.slider_spline_resolution.desc": "Spline-Auflösung auf der %0 Achse ändern (%1)",
	"action.slider_spline_resolution.u.desc_precision": "Ring Segmente",
	"action.slider_spline_resolution.v.desc_precision": "Rohrsegmente",
	"action.slider_spline_radius": "Splineradius",
	"action.slider_spline_radius.desc": "Splineradius verändern",
	"action.slider_spline_handle_tilt": "Griffneigung",
	"action.slider_spline_handle_tilt.desc": "Ändere die Neigung eines Splinegriffs",
	"action.slider_spline_handle_size": "Griffgröße",
	"action.slider_spline_handle_size.desc": "Ändere die Größe eines Splinegriffs",
	"action.blend_mode.lighten": "Aufhellen",
	"action.blend_mode.darken": "Abdunkeln",
	"action.weight_brush": "Gewicht-Pinsel",
	"action.weight_brush.desc": "Male die Gewichtung von Eckpunkten für Skelettdeformationen in Maschen ein",
	"action.convert_minecraft_skin_variant": "Konvertiere Dünne/Breite Skin Varianten",
	"action.convert_minecraft_skin_variant.desc": "Wechsle zwischen dem Skinmodell für klassische breite Skins (Steve) oder schlanke Skins (Alex). Optional kann die Textur automatisch an das neue Modell angepasst werden",
	"action.custom_skin_poses": "Benutzerdefinierte Skin Posen",
	"action.custom_skin_poses.desc": "Lade ein benutzerdefiniertes Preset für die Haltung des Modells",
	"action.custom_skin_poses.update": "Pose aktualisieren",
	"action.custom_skin_poses.update.desc": "Überschreibe die gespeicherte Haltung mit der aktuellen Haltung des Modells",
	"action.add_custom_skin_pose": "Benutzerdefinierte Haltung hinzufügen",
	"action.add_custom_skin_pose.desc": "Speichere die aktuelle Haltung des Modells als Haltungs-Preset",
	"action.export_stl": "STL exportieren",
	"action.export_stl.desc": "Exportiere das Modell als STL Datei für den 3D-Druck",
	"action.add_element": "Element hinzufügen",
	"action.add_element.desc": "Füge ein neues Element aus der Liste der Arten von Elementen zum Projekt hinzu",
	"action.add_spline": "Spline hinzufügen",
	"action.add_spline.desc": "Fügt einen neuen Spline hinzu",
	"action.add_billboard": "Billboard hinzufügen",
	"action.add_billboard.desc": "Fügt ein neues Billboard hinzu, ein flaches Element, das sich stets zur Kamera ausrichtet",
	"action.add_armature": "Skelett hinzufügen",
	"action.add_armature.desc": "Fügt ein Skelett hinzu, das durch Animation Maschen verformen und animieren kann",
	"action.add_armature_bone": "Knochen hinzufügen",
	"action.add_armature_bone.desc": "Fügt einen Knochen zum Skelett hinzu",
	"action.search_textures": "Suche Texturen",
	"action.search_textures.desc": "Suche Texturen nach Namen",
	"action.search_animations": "Suche Animationen",
	"action.search_animations.desc": "Suche Animationen nach Namen",
	"action.spline_selection_mode": "Spline Auswahlmodus",
	"action.spline_selection_mode.object": "Objekt",
	"action.spline_selection_mode.handles": "Griffe",
	"action.spline_render_mode": "Geometrisch",
	"action.spline_render_mode.mesh": "Masche",
	"action.spline_render_mode.path": "Pfad",
	"action.spline_render_mode.desc": "Die Art der Form, in der der Spline gerendert wird",
	"action.spline_uv_mode": "UV Modus",
	"action.spline_uv_mode.length_accurate": "Nach Länge",
	"action.spline_uv_mode.uniform": "Einheitlich",
	"action.spline_uv_mode.per_segment": "Pro Segment",
	"action.spline_uv_mode.desc": "In welcher Art die UVs eines Spline-Rohrs angeordnet werden sollen.",
	"action.spline_ring_segments": "Ringsegmente",
	"action.spline_ring_segments.desc": "Anzahl der Unterteilungen des Splines pro Ring",
	"action.spline_tube_segments": "Rohrsegmente",
	"action.spline_tube_segments.desc": "Anzahl der Unterteilung des Splines entlang des Pfades",
	"action.spline_tube_radius": "Rohr-Radius",
	"action.spline_tube_radius.desc": "Stelle den Rohr-Radius des Splines ein",
	"action.spline_display_space": "Räumlichkeit anzeigen",
	"action.spline_display_space.desc": "Räumlichkeitsanzeiger entlang des Splinepfades einblenden",
	"action.spline_handle_mode": "Spline-Griffmodus",
	"action.spline_handle_mode.desc": "Der Modus zur Transformation der Spline-Griffe",
	"action.spline_handle_mode.aligned": "Bündig",
	"action.spline_handle_mode.free": "Frei",
	"action.spline_handle_mode.mirrored": "Gespiegelt",
	"action.slider_weight_brush_size": "Gewicht-Pinsel: Größe",
	"action.weight_brush_xray": "Gewicht-Pinsel: XRay-Modus",
	"action.weight_brush_xray.desc": "Wenn aktiv, wird der Gewicht-Pinsel alle Eckpunkte erreichen, auch die, die nicht sichtbar auf der Oberfläche liegen",
	"action.apply_spline_rotation": "Rotation anwenden",
	"action.apply_spline_rotation.desc": "Die Dregung des Splines zurücksetzen und stattdessen auf dessen Geometrie anwenden",
	"action.extrude_spline_selection": "Spline Extrudieren",
	"action.extrude_spline_selection.desc": "Splines an ausgewählten Griffen extrudieren",
	"action.split_spline": "Spline trennen",
	"action.split_spline.desc": "Den Spline an der Position des ausgewählten Griffs in zwei Teile zerteilen",
	"action.divide_spline_curve": "Splinesegment aufteilen",
	"action.divide_spline_curve.desc": "Das Splinesegment in zwei neue Segmente mit neuem Griff am Schnittpunkt aufteilen",
	"action.set_vertex_weights": "Eckpunktgewichtungen festlegen",
	"action.set_vertex_weights.desc": "Die Gewichtungen der ausgewählten Eckpunkte auf einem bestimmten Knochen auf einen festen Wert setzen",
	"action.calculate_vertex_weights": "Eckpunktgewichtungen errechnen",
	"action.calculate_vertex_weights.desc": "Automatische Eckpunktgewichtungen anhand der Positionen der Knochen berechnen",
	"action.shelf_alignment": "Ausrichtung in Regal",
	"action.shelf_alignment.desc": "Stelle die vertikale Ausrichtung des Items in einem Regal ein",
	"action.shelf_alignment.top": "Oben ausgerichtet",
	"action.shelf_alignment.bottom": "Unten ausgerichtet",
	"action.view_mode.vertex_weight": "Vertex-Gewichtung",
	"action.view_mode.weighted_bone_colors": "Gewichtete Knochenfarben",
	"action.create_animation_group": "Animationsgruppe hinzufügen",
	"action.create_animation_group.desc": "Erstelle eine Gruppe aus Animationen",
	"action.move_graph_keyframes_up": "Keyframegraph nach oben bewegen",
	"action.move_graph_keyframes_down": "Keyframegraph nach uten bewegen",
	"menu.skin": "Skin",
	"menu.text_edit.expression_editor": "Ausdruckseditor",
	"menu.color_picker.picker_type.normal": "Normal Map",
	"menu.texture.flipbook_animation": "Animierte Textur",
	"menu.panel.attach_to": "Anhängen an",
	"menu.animation.playing": "Wiedergabe",
	"menu.animation_file.save_as": "Speichern unter",
	"menu.animator.quaternion_interpolation": "Quaternionen-Interpolation",
	"edit.extrude_spline_selection.extend": "Verlängern",
	"edit.divide_spline_curve.position": "Position",
	"group.bedrock_binding": "Binden",
	"group.cem_attach": "CEM Anheften",
	"group.cem_model": "CEM Modell",
	"group.cem_scale": "CEM Skalierung",
	"cube.rescale": "Vergrößerung",
	"cube.rescale.desc": "Quader vergrößern, um ihre Drehung auszugleichen",
	"mesh.shading": "Schattierung",
	"mesh.shading.flat": "Flach",
	"mesh.shading.smooth": "Glatt",
	"spline_mesh.cyclic": "Geschlossen",
	"spline_mesh.cyclic.desc": "Ob der Spline eine geschlossene Schlaufe bilden soll",
	"billboard.offset": "Versatz",
	"billboard.facing_mode": "Ausrichtung",
	"billboard.facing_mode.lookat": "Draufsicht",
	"billboard.facing_mode.lookat_y": "Draufsicht Y",
	"billboard.facing_mode.rotate": "Rotierend",
	"billboard.facing_mode.rotate_y": "Drehen Y",
	"armature_bone.connected": "Verbunden",
	"reference_image.blueprint": "Angeheftete Blaupause",
	"codec.image.alpha_channel": "Alphakanal",
	"codec.image.animation_fps": "Animations-FPS",
	"panel.palette": "Palette",
	"panel.keyframe.change_effect_file": "Effektdatei ändern",
	"panel.transform": "Transformiere",
	"panel.element.spline_dimensions": "Splinedimensionen",
	"display.slot.on_shelf": "Regal",
	"display.reference.shelf": "Regal (Alle Slots)",
	"display.reference.shelf_left": "Regal (Linker Slot)",
	"display.reference.shelf_center": "Regal (Mittlerer Slot)",
	"display.reference.shelf_right": "Regal (Rechter Slot)",
	"message.newer_project_format_version.title": "Veraltetes Programm",
	"message.newer_project_format_version.message": "Die Datei wurde in einer neueren Version von Blockbench gespeichert. Update Blockbench auf die Version %0 oder neuer, um die Datei korrekt öffnen zu können",
	"message.load_images.add_layer": "Als Ebene hinzufügen",
	"message.load_images.category.add_to_project": "Zu Projekt hinzufügen",
	"message.load_images.category.new_project": "Neues Projekt",
	"message.load_palette.title": "Palette laden",
	"message.load_palette.message": "Bist du die sicher, dass du diese Palette laden möchtest? Dadurch wird die aktuelle Palette ersetzt werden.",
	"dialog.set_vertex_weights.weight": "Gewichtung",
	"dialog.set_vertex_weights.overwrite": "Andere Knochen überschreiben",
	"action.element_render_order.short": "Rendering-Reihenfolge",
	"action.element_render_order.desc": "Die Rendering-Reihenfolge von Elementen. Diese kann verwendet werden, um Probleme zu beheben, bei denen Elemente hinter anderen Elementen mit transparenter Textur nicht mehr angezeigt werden. Verwende die Option Auto für undurchsichtige Elemente.",
	"spline.shading.flat": "Flach",
	"spline.shading.smooth": "Glatt",
	"spline.shading": "Schattierung",
	"spline.shading.desc": "Die Schattierung des Splinerohrs",
	"action.slider_weight_brush_limit": "Gewicht-Pinsel: Limit",
	"action.slider_weight_brush_limit.desc": "Das obere Limit, für wieviel Gewichtung der Gewicht-Pinsel einem Eckpunkt zuweisen kann",
	"action.weight_brush_blend_mode": "Gewicht-Pinsel: Mischmodus",
	"action.weight_brush_blend_mode.set": "Festlegen",
	"action.weight_brush_blend_mode.add": "Addieren",
	"action.apply_texture_to_elements": "Textur auf Elemente anwenden",
	"action.apply_texture_to_elements.desc": "Die ausgewählte Textur auf die ausgewählten Elemente anwenden",
	"menu.panel.reset_size": "Größe zurücksetzen",
	"action.import_layer": "Ebene importieren",
	"action.import_layer.desc": "Bilddateien als Ebenen importieren",
	"menu.collection.open_file": "Datei öffnen",
	"layout.version": "Version",
	"settings.status_bar_transform_sliders": "Transformationsinputs in Statusleiste anzeigen",
	"settings.status_bar_transform_sliders.desc": "Zeigt die Transform Input Werkzeugleiste des ausgewählten Werkzeuges in der Statusleiste statt in Transformierpanel an",
	"settings.default_bedrock_format": "Standard-Bedrockformat",
	"settings.default_bedrock_format.desc": "Das Standardformat, das verwendet wird, um Bedrock Modelle zu laden, wenn durch den Kontext kein bestimmtes Format ersichtlich ist.",
	"settings.limit_brush_opacity_per_stroke": "Pinseldeckkraft pro Pinsenstrich begrenzen",
	"settings.limit_brush_opacity_per_stroke.desc": "Begrenze die Deckkraft innerhalb eines einzelnen Pinsenstriches auf den Wert des Deckkraftreglers. Bei Verwendung eines weichen Pinsels kann hierbei ungewolltes Bildrauschen entstehen.",
	"action.merge_splines": "Splines kombinieren",
	"action.merge_splines.desc": "Kombiniere mehrere Splines zu einem",
	"settings.default_java_block_version": "Standard Java Block/Item Version",
	"settings.default_java_block_version.desc": "Voreingestellte Formatversion wenn ein neues Java Block/Item Modell erstellt wird, oder ein bestehendes ohne Version geöffnet wird",
	"data.bounding_box": "Begrenzungsbox",
	"keys.option": "Option",
	"keys.slide_lmb_horizontal": "Linksklick horizontal ziehen",
	"keys.slide_lmb_vertical": "Linksklick vertikal ziehen",
	"keys.slide_rmb_horizontal": "Rechtsklick horizontal ziehen",
	"keys.slide_rmb_vertical": "Rechtsklick vertikal ziehen",
	"message.recover_backup.unknown_project": "Unbekanntes Projekt",
	"message.recover_backup.discard_others": "Alle anderen verwerfen",
	"message.unsupported_file_extension.title": "Dateiformat nicht unterstützt",
	"message.unsupported_file_extension.message": "Die Datei %0 kann nicht geöffnet werden, das Format wird nicht unterstützt. Eventuell wird ein Plugin benötigt.",
	"message.unsupported_file_extension.open_in_default_program": "In Standardprogramm öffnen",
	"dialog.project.uv_size": "UV Größe",
	"dialog.collection.offset": "Versatz",
	"dialog.texture.fps": "FPS",
	"dialog.texture.fps.desc": "Bilder pro Sekunde für die Wiedergabe animierter Texturen",
	"dialog.edit_uv_size.title": "UV Größe ändern",
	"dialog.edit_uv_size.target": "Ziel",
	"dialog.edit_uv_size.adjust": "Anpassen",
	"dialog.edit_uv_size.adjust.adjust_uv": "UV kontern",
	"dialog.edit_uv_size.adjust.adjust_scale": "UV & Skalierung kontern",
	"dialog.edit_uv_size.adjust.keep": "UV beibehalten",
	"dialog.edit_uv_size.target_size": "Neue UV Größe",
	"dialog.edit_uv_size.preset.original": "Original",
	"dialog.edit_uv_size.preset.match_texture": "Von Textur übernehmen",
	"dialog.edit_uv_size.result": "Ergebnis",
	"dialog.edit_uv_size.result.textures": "Texturen",
	"dialog.adjust_brightness_contrast.brightness": "Helligkeit",
	"dialog.adjust_brightness_contrast.contrast": "Kontrast",
	"dialog.adjust_saturation_hue.saturation": "Sättigung",
	"dialog.adjust_saturation_hue.hue": "Farbton",
	"dialog.adjust_opacity.mode": "Modus",
	"dialog.adjust_opacity.mode.multiply": "Multiplizieren",
	"dialog.adjust_opacity.mode.set": "Festwert",
	"dialog.bedrock_bounding_box.type": "Typ",
	"dialog.bedrock_bounding_box.type.collision_box": "Kollision",
	"dialog.bedrock_bounding_box.type.selection_box": "Auswahlbox",
	"dialog.bedrock_bounding_box.type.hitbox": "Hitbox",
	"dialog.bedrock_bounding_box.hitbox_note": "Hinweis: Entity-Hitboxen funktionieren nur bis zu einer bestimmten Größe und passen sich unter Umständen nicht der Drehung des Entity im Spiel an.",
	"dialog.bedrock_bounding_box.collision_note": "Hinweis: Entity-Kollisionsboxen unterstützen nur eine zentrierte Box mit gleicher Länge und Breite.",
	"dialog.bedrock_bounding_box.no_bounding_boxes": "In diesem Projekt sind keine Begrenzungsboxen vorhanden",
	"dialog.install_plugins_from_list.ids": "Plugin IDs",
	"dialog.install_plugins_from_list.info": "Installiere mehrere Plugins aus einer Liste von IDs. Bitte überprüfe, ob du wirklich alle Plugins benötigst. Wenn nicht verwendete Plugins installiert bleiben, kann das unter Umständen zu Fehlern und Kompatibilitätsproblemen mit zukünftigen Updates führen.",
	"dialog.copy_installed_plugins.details": "Mit Details",
	"dialog.flip_animation.phase_offset": "Phasenversatz",
	"dialog.flip_animation.phase_offset.off": "Aus",
	"dialog.flip_animation.phase_offset.custom": "Anderer Wert",
	"dialog.flip_animation.clear_opposite": "Gegenseite überschreiben",
	"settings.flipbook_textures_in_animation": "Animierte Texturen in Animationen abspielen",
	"settings.flipbook_textures_in_animation.desc": "Spielt Animierte Texturen zur Vorschau synchron mit der Animationszeitleiste ab",
	"settings.display_uv": "UV Flächen anzeigen",
	"settings.display_uv.desc": "Wähle aus, welche UV Flächen im UV Editor angezeigt werden",
	"settings.display_uv.selected_faces": "Nur ausgewählte Flächen",
	"settings.display_uv.selected_elements": "Alle Flächen aller ausgewählter Elemente",
	"settings.display_uv.all_elements": "Alle Flächen aller Elemente",
	"settings.local_position_values": "Lokale Positionswerte",
	"settings.local_position_values.desc": "Verwende Lokale Werte für die Positions im Transformationspanel",
	"settings.transform_cube_from_center": "Quader von der Mitte aus positionieren",
	"settings.transform_cube_from_center.desc": "Die Position von Quadern von der Mitte statt von der Ecke aus verändern",
	"settings.color_picker_tool_switch": "Werkzeugwechsel durch Farbpipette",
	"settings.color_picker_tool_switch.desc": "Wechselt zum Radiergummiwerkzeug, wenn mit der Farbpipette ein transparenter Pixel ausgewählt wird. Wechsle zurück zum Pinsel, wenn eine Farbe ausgewählt wird",
	"keybind.preview_scroll_zoom": "Ansicht zoomen",
	"keybind.uv_editor_scroll_zoom": "UV / 2D Editor zoomen",
	"action.blend_mode.alpha_mask": "Alphamaske",
	"action.swap_tools.hold": "Gedrückthalten zum Wechseln (Farbpipette)",
	"action.import_bedrock_voxel_shape": "Bedrock Voxelform importieren",
	"action.import_bedrock_voxel_shape.desc": "Importiere eine Voxelform aus einer JSON Datei in das geöffnete Projekt",
	"action.export_bedrock_voxel_shape": "Bedrock Voxelform exportieren",
	"action.export_bedrock_voxel_shape.desc": "Exportiere die Begrenzungsboxen im geöffneten Projekt als Bedrock Voxelform",
	"action.plugins_window_menu": "Menü",
	"action.copy_installed_plugins": "Installierte Plugins kopieren",
	"action.copy_installed_plugins.desc": "Generiert und kopiert eine Liste aller installierter Plugins",
	"action.install_plugins_from_list": "Plugins von Liste installieren",
	"action.install_plugins_from_list.desc": "Installiert Plugins aus einer Liste von Plugin IDs",
	"action.add_bounding_box": "Begrenzungsbox hinzufügen",
	"action.add_bounding_box.desc": "Fügt eine neue Begrenzungsbox hinzu",
	"action.split_alpha_into_layer": "Alphakanal in neue Ebene teilen",
	"action.split_alpha_into_layer.desc": "Teilt den Alphakanal der Textur in eine Farbebene und eine Alphamaske",
	"action.generate_bedrock_block_box": "Kollisions-/Auswahlkomponente kopieren",
	"action.generate_bedrock_block_box.desc": "Generiert eine Kollisions- oder Auswahlkomponente für Minecraft Bedrock Edition Blöcke",
	"action.generate_bedrock_entity_box": "Kollisions-/Hitboxkomponente kopieren",
	"action.generate_bedrock_entity_box.desc": "Generiert eine Kollisions- oder Custom-Hit-Test Komponente für Minecraft Bedrock Edition Entities",
	"action.refresh_texture": "Texture neu laden",
	"action.refresh_texture.desc": "Die Textur neu von der Datei laden",
	"action.move_uv_to_cursor": "UV zum Cursor bewegen",
	"action.move_uv_to_cursor.desc": "Bewegt die ausgewählten UV Flächen zur position des Mauscursors",
	"action.edit_mode_uv_overlay": "Alle Elemente anzeigen",
	"action.round_keyframe_values": "Keyframewerte runden",
	"action.round_keyframe_values.desc": "Runde alle Werte der ausgewählten Keyframes",
	"action.keyframe_column_create.all_channels": "Alle Kanäle",
	"action.keyframe_column_create.all_channels.desc": "Alle Kanäle mit Keyframes initialisieren, auch wenn diese bisher noch keine Keyframes hatten",
	"action.add_all_to_timeline": "Alle zur Zeitleiste hinzufügen",
	"action.mirror_animating": "Gespiegeltes Animieren",
	"action.mirror_animating.desc": "Spiegelt Änderungen an Animationen automatisch auf die Gegenseite",
	"action.copy_animation_pose": "Animations-Pose kopieren",
	"action.copy_animation_pose.desc": "Kopiert alle Keyframes, um die aktuelle Animations-Pose zu replizieren",
	"menu.texture.file_format": "Dateiformat",
	"menu.texture.wrap_mode": "Ausweitungsmodus",
	"menu.texture.wrap_mode.limited": "Begrenzt",
	"menu.texture.wrap_mode.repeat": "Wiederholen",
	"menu.texture.wrap_mode.clamp": "Kanten strecken",
	"edit.reparent_selection.adjust_position": "Globale Transformation erhalten",
	"texture_mesh.texture_name": "Texturenname",
	"display.slot.embedded": "Eingebettet",
	"display.animate_preview": "Vorschauanimation",
	"display.reference.flower_pot": "Blumentopf"
}